module.exports = {
  "action": {
    "search": "查询",
    "search1": "查看",
    "creat": "新建",
    "creat1": "创建",
    "creat2": "新增",
    "renew": "更新",
    "renew1": "刷新",
    "recheck": "重新检查",
    "import": "导入",
    "Importing": "导入中...",
    "export": "导出",
    "input": "请输入",
    "improve": "请完善",
    "select": "请选择",
    "select1": "选中",
    "write": "填写",
    "whether": "是否",
    "edit": "编辑",
    "change": "修改",
    "copy": "复制",
    "modifiable": "可修改",
    "delete": "删除",
    "delete1": "清除",
    "regain": "确认恢复吗？",
    "stopusing": "确定停用吗",
    "Enable": "启用",
    "Deactivate": "停用",
    "expand": "展开",
    "fold": "收起",
    "photograph": "拍照",
    "login": "登录",
    "login1": "用户登录",
    "logout": "退出登录",
    "contract": "联系客服",
    "wxScan": "请用微信扫码",
    "modifyPwd": "修改密码",
    "confirm": "确定",
    "confirm1": "确认",
    "convertTo": "转为",
    "return": "返回",
    "return1": "归还",
    "return2": "已归还",
    "noreturn": "未归还",
    "noreturn1": "未完全归还",
    "previousPage": "上一页",
    "nextPage": "下一页",
    "use": "使用",
    "add": "添加",
    "add1": "加入",
    "upload": "上传",
    "save": "保存",
    "save1": "暂存",
    "cancel": "取消",
    "close": "关闭",
    "scan": "扫描",
    "scan1": "扫",
    "operate": "操作",
    "synchronous": "同步",
    "yes": "是",
    "no": "否",
    "have": "有",
    "nothing": "无",
    "deactivate": "停用",
    "restore": "恢复",
    "statistics": "统计",
    "gather": "采集",
    "applyfor": "申请",
    "newapplyfor": "新申请",
    "Notappliedfor": "未申请",
    "print": "打印",
    "need": "需要",
    "notNeed": "不需要",
    "automatic": "自动",
    "delayed": "延时",
    "describe": "描述",
    "association": "关联",
    "independence": "无关",
    "remind": "提醒",
    "handle": "处理",
    "way": "方式",
    "calculate": "核算",
    "binding": "绑定",
    "unbind": "解绑",
    "binding1": "已绑定",
    "count": "计数",
    "Bold": "加粗",
    "disassemble": "拆卸",
    "examine": "审核",
    "record": "录入",
    "record1": "记录 ",
    "registration": "登记",
    "Collection": "下收",
    "sterilization": "灭菌",
    "disinfect": "消毒",
    "recycle": "回收",
    "recycle1": "可回收的",
    "Unrecycled": "未回收",
    "package": "包装",
    "package1": "检查包装",
    "package2": "配包",
    "packagetwo": "打包",
    "package3": "已打包",
    "Tbpackaged": "待包装(已清洗质检)",
    "Secondinspection": "二检",
    "Unpacked": "未打包",
    "clean": "清洗",
    "CleaningMachine": "清洗机",
    "Sterilizer": "灭菌器",
    "cleanquality": "清洗质检",
    "biological": "生物监测",
    "check": "清点",
    "out": "发放",
    "receive": "接收",
    "Returnpackage": "还包",
    "borrow": "借包",
    "Backwash": "回洗",
    "Delivery": "送物",
    "Back": "回退",
    "urgent": "加急",
    "infect": "感染",
    "supply": "补充",
    "patch": "补",
    "more": "更多",
    "complete": "完成",
    "success": "成功",
    "fail": "失败",
    "hand": "手动",
    "shield": "屏蔽",
    "maintenance": "维护",
    "Oneclick": "一键",
    "obtain": "获取",
    "default": "默认",
    "display": "显示",
    "Hidden": "隐藏",
    "Hidden1": "已隐藏",
    "Unhidden": "未隐藏",
    "repeatable": "重复",
    "Norepeatable": "不可重复",
    "caption": "说明",
    "fit": "设置",
    "manage": "管理",
    "Handover": "交接",
    "Patchwork": "补打",
    "searchfor": "搜索",
    "Centralized": "集采",
    "action": "操作",
    "reset": "重置",
    "take": "拍照"
  },
  "object": {
    "name": "名称",
    "name1": "名",
    "name2": "类名",
    "userName": "用户名",
    "people": "人员",
    "user": "用户",
    "jobNumber": "工号",
    "code": "刻码",
    "code1": "码",
    "code2": "编码",
    "Totalcode": "总码",
    "pinyin": "拼音",
    "instrument": "器械",
    "instrumentset": "器械包",
    "set": "包",
    "information": "信息",
    "Implants": "植入物",
    "unImplants": "非植入物",
    "hospital": "医院",
    "In": "院内",
    "Outside": "院外",
    "center": "处理中心",
    "center1": "院区",
    "cssd": "供应室",
    "department": "科室",
    "DepartmentGroup": "科室组",
    "supplier": "供应商",
    "container": "篮筐",
    "container1": "托盘",
    "disposables": "耗材",
    "Thispackage": "该包",
    "article": "物品",
    "type": "类型",
    "page": "页面",
    "list": "清单",
    "table": "列表",
    "log": "日志",
    "annex": "附件",
    "detail": "明细",
    "detail1": "明细小节",
    "longTerm": "长租",
    "shortTerm": "短租",
    "group": "分组",
    "password": "密码",
    "tel": "电话",
    "email": "邮箱",
    "address": "地址",
    "brand": "品牌",
    "unitPrice": "单价",
    "number": "次数",
    "number1": "数量",
    "number2": "人数",
    "pieces": "件数",
    "remarks": "备注",
    "weight": "重量",
    "specifications": "规格",
    "model": "型号",
    "g": "克",
    "image": "照片",
    "image1": "图片",
    "date": "日期",
    "time": "时间",
    "content": "内容",
    "file": "文件",
    "base": "基数",
    "base1": "基础",
    "No": "暂无",
    "data": "数据",
    "whole": "全部",
    "all": "全选",
    "state": "状态",
    "class": "类别",
    "inventory": "库存",
    "location": "位置",
    "company": "公司",
    "tag": "标签",
    "tag1": "标签号",
    "trussUp": "捆绑",
    "day": "天",
    "day1": "天数",
    "individual": "个",
    "validity": "效期",
    "validity1": "有效期",
    "warning": "预警",
    "collocation": "组配",
    "collocation1": "配组",
    "processe": "工序",
    "property": "财产",
    "sort": "排序",
    "batch": "批次",
    "batch1": "批量",
    "document": "单据",
    "support": "技术支持",
    "ade": "不良事件",
    "ade1": "不良事件登记",
    "problem": "问题",
    "material": "材料",
    "template": "模板",
    "cost": "费",
    "cost1": "成本",
    "sum": "金额",
    "total": "总和",
    "total1": "总计",
    "sumtotal": "总数",
    "Thirdpartysystem": "第三方系统",
    "note": "注意事项",
    "other": "其他",
    "level": "级别",
    "demand": "需求",
    "tower": "台",
    "units": "台次",
    "Station": "台号",
    "Filteritems": "筛选项",
    "Potnumber": "锅次",
    "Pot": "锅号",
    "circulatingnurse": "巡回护士",
    "scrubnurse": "洗手护士",
    "reason": "原因",
    "post": "岗位",
    "education": "学历",
    "title": "职称",
    "gender": "性别",
    "gender1": "男女",
    "equipment": "设备",
    "produce": "厂家",
    "produceTwo": "生产厂家",
    "delivery": "送货人",
    "deliverytime": "送货时间",
    "contactinformation": "联系方式",
    "patient": "病人",
    "outpatientservice": "门诊",
    "moniker": "姓名",
    "male": "男",
    "female": "女",
    "Bednumber": "床号",
    "age": "年龄",
    "ward": "病区",
    "Chiefsurgeon": "主刀医生",
    "operation": "手术",
    "Proposedimplementation": "拟施",
    "Powertools": "动力工具",
    "tool": "工具",
    "steelplate": "钢板",
    "screw": "螺钉",
    "fullscreen": "全屏",
    "exit": "退出",
    "udi": "UDI",
    "rfid": "RFID",
    "duration": "工作时长",
    "language": "设置语言",
    "chinese": "简体中文",
    "english": "英语",
    "triditionalCN": "繁体中文",
    "thai": "泰语",
    "loading": "加载中",
    "dictionaryName": "字典名称",
    "dictionaryType": "字典类型",
    "dataLabel": "数据标签",
    "dataKeyValue": "数据键值",
    "displaySorting": "显示排序",
    "divtLable": "字典标签"
  },
  "describe": {
    "basic": "基本",
    "please": "请",
    "wait": "稍后",
    "foreign": "外来",
    "daixiao": "代消",
    "dressing": "敷料",
    "or": "或",
    "and": "和",
    "do": "为",
    "Cannotbe": "不可为",
    "use": "以",
    "stop": "已",
    "selected": "已选",
    "belongTo": "归属",
    "affiliation": "所属",
    "standard": "标准",
    "maximum": "最大",
    "regular": "固定",
    "special": "特殊",
    "prevail": "为准",
    "multiple": "多重",
    "settlement": "结算",
    "front": "前",
    "after": "后",
    "difference": "差异",
    "excessive": "多余",
    "lack": "缺少",
    "must": "必须",
    "greaterthan": "大于",
    "lessthan": "小于",
    "empty": "空",
    "correct": "正确的",
    "nothave": "没有",
    "right": "正常",
    "saveas": "另存为新包",
    "amountto": "合计",
    "choose": "按包名选择回收",
    "ordinary": "普通",
    "documentation": "归档",
    "unmatched": "未匹配",
    "daily": "日常"
  },
  "prompt": {
    "notnull": "不能为空",
    "clickimg": "点击查看大图",
    "Existingproblems": "扫码存在问题，请检查输入法的中英模式或大小写",
    "Existed": "该包已经存在待回收列表中",
    "Unchecked": "不选默认是当天",
    "Unchecked1": "已经发送过敷料包，是否继续",
    "notprint": "pda暂不支持打印",
    "ShowOnly": "只显示使用最新记录",
    "error": "获取缓存数据出错",
    "delete": "确认删除吗?",
    "convert": "确认转为耗材吗？",
    "enter": "输入完成按Enter键添加",
    "saveduplicate": "存在已绑定的udi，请处理后重新检查",
    "msg": "可添加udi的位置不足，继续添加吗？",
    "msg1": "-1 是默认值，不自动发放；",
    "msg2": "0 是自动发放且立即发放；",
    "msg3": ">0 是自动发放且延时发放的时间(单位：分钟)",
    "msg4": "灭菌有效期规范化设置，通过包装材料、处理方式、季节等进行自动判定；",
    "msg5": "并对相关设置添加说明；如需修改，必须给出修改的原因；",
    "msg6": "设置收费模式，并做出相关收费说明？",
    "msg7": "该物品已经存在列表中，请勿重复添加",
    "msg8": "该物品不存在系统中，是否新建",
    "msg9": "请填写正确的还包数量",
    "msg10": "数量必须大于0",
    "msg11": "请扫描正确的码",
    "msg12": "请扫描篮筐码",
    "msg13": "请选择需要预处理的物品",
    "msg14": "请选择需要分类的器械包",
    "msg15": "请选择退回物品",
    "msg16": "至少保留一条篮筐数据",
    "msg17": "请扫描预处理人",
    "msg18": "该人员码不存在",
    "msg19": "请选择物品",
    "msg20": "确认删除吗？",
    "msg21": "必须选择补录原因!",
    "msg22": "该篮筐不在列表",
    "msg23": "扫描或选择清洗程序",
    "msg24": "其中有包不支持当前清洗方式，是否继续",
    "msg25": "其中有包不支持当前清洗方式，请调整清洗方式或物品",
    "msg26": "请选择清洗方式",
    "msg27": "请扫描清洗机程序码",
    "msg28": "请选择开始清洗的人员和清洗程序",
    "msg29": "请扫描或选择清洗机",
    "msg30": "请扫描或选择清洗程序",
    "msg31": "重新清洗成功",
    "msg32": "开始运行成功",
    "msg33": "清洗成功",
    "msg34": "清洗补录时间比当前物品回收的时间还早",
    "msg35": "请确认是否继续",
    "msg36": "当前已选择篮筐",
    "msg37": "该设备未完成登记，请完成后运行操作",
    "msg38": "清洗设备外表面洁净与否",
    "msg39": "清洗设备显示屏",
    "msg40": "清洗设备打印纸",
    "msg41": "清洗设备门胶条清洁与否",
    "msg42": "水电气故障与否",
    "msg43": "清洗设备管道通畅",
    "msg44": "酶油量是否充足",
    "msg45": "纯化水电导率（≤15us/cm2）",
    "msg46": "清洗设备舱体洁净与否",
    "msg47": "清洗设备过滤网清洁",
    "msg48": "喷淋臂能否自由旋转",
    "msg49": "喷淋臂喷嘴有无阻塞",
    "msg50": "清洗设备清洗架清洁",
    "msg51": "请将表单填写完整",
    "msg52": "登记完成",
    "msg53": "请扫描需要下架的包",
    "msg54": "请选择灭菌器和灭菌架",
    "msg55": "请扫描灭菌员",
    "msg56": "该灭菌器没有进行测漏合格测试，是否继续操作？",
    "msg57": "该人员不是灭菌员",
    "msg58": "请选择灭菌器及程序",
    "msg59": "该设备程序规定每天每次需要做生物监测，是否继续",
    "msg60": "该设备程序规定每天首次需要做生物监测，是否继续",
    "msg61": "该灭菌器没有进行测漏合格测试，无法继续操作",
    "msg62": "该灭菌器没有进行BD合格测试，无法继续操作",
    "msg63": "该灭菌器没有进行BD测试，是否继续操作？",
    "msg64": "请扫描灭菌器程序码",
    "msg65": "请选择开始灭菌的人员和灭菌程序",
    "msg66": "请选择灭菌器",
    "msg67": "请选择待灭菌物品",
    "msg68": "所选物品未到灭菌时间，不可补录",
    "msg69": "请填写删除原因",
    "msg70": "请扫灭菌架",
    "msg71": "请先选择灭菌器",
    "msg72": "请选择需要标记的包",
    "msg73": "请标记需要生物监测的包后再开始灭菌",
    "msg74": "请选择生物监测原因",
    "msg75": "存在处理方式不相同的包，不能开始灭菌",
    "msg76": "列表中存在处理方式不相同的包，是否继续？",
    "msg77": "确定下架吗？",
    "msg78": "请扫描包码",
    "msg79": "确定删除吗？",
    "msg80": "上传成功",
    "msg81": "灭菌设备外表面洁净与否",
    "msg82": "灭菌设备舱体洁净与否",
    "msg83": "灭菌设备门胶条洁净与否",
    "msg84": "灭菌设备显示屏",
    "msg85": "灭菌设备打印纸",
    "msg86": "安全阀在校验期内",
    "msg87": "压力表在校验期内",
    "msg88": "请选择不合格原因",
    "msg89": "请选择检查方法",
    "msg90": "未找到清洗记录",
    "msg91": "未找到对应的清洗记录",
    "msg92": "上传图片成功",
    "msg93": "删除图片成功",
    "msg94": "确认结束清洗吗？",
    "msg95": "清洗结束",
    "msg96": "还未清洗完成，不能合格",
    "msg97": "扫描清洗质检人",
    "msg98": "清洗质检成功",
    "msg99": "请选择需要清洗质检物品",
    "msga1": "会退回至待分类",
    "msga2": "清洗不合格原因",
    "msga3": "请选择原因",
    "msga4": "灭菌质量抽查结果统计",
    "msga5": "灭菌物品质量监测",
    "msga6": "点击图片放大",
    "msga7": "生物培养管异常",
    "msga8": "请扫描第二质检人",
    "msga9": "请扫描生物质检人",
    "msga10": "请扫描抽查人",
    "msga11": "包外是否潮湿",
    "msga12": "包外是否有水雾或珠",
    "msga13": "器械清洁度",
    "msga14": "确认结束灭菌吗？",
    "msga15": "请上传质检合格图片",
    "msga16": "灭菌质检成功",
    "msga17": "扫描生物质检人",
    "msga18": "扫描生物质检人并选择不合格原因",
    "msga19": "该扫描生物质检人",
    "msge20": "质检人不能相同",
    "msga21": "生物监测成功",
    "msga22": "灭菌不合格原因",
    "msga23": "确认提前放行吗？",
    "msga24": "请输入包码",
    "msga25": "查询成功",
    "msga26": "请输入正确的包码",
    "msga27": "请填写包码",
    "msga28": "请选择摆放层",
    "msga29": "请选择摆放位置",
    "msga30": "请选择摆放方式",
    "msga31": "请选择抽查结果",
    "msga32": "会退回至待灭菌，确定继续吗？",
    "msga33": "提前放行信息",
    "msga34": "扫描灭菌质检人",
    "msga35": "请扫描人员",
    "msga36": "灭菌质量抽查结果统计",
    "msga37": "列表信息有更新，请刷新列表",
    "msga38": "请选择发放科室",
    "msga39": "发放物品为空",
    "msga40": "发放成功",
    "msga41": "请选择需要打印的数据",
    "msga42": "本人已扫码总数",
    "msga43": "输入后回车代替扫码",
    "msga44": "查看加急器械包",
    "msga45": "查看发放记录",
    "msga46": "批量取消发放",
    "msga47": "待发放计划打印",
    "msga48": "当前查询结果包数过多，不能合并表格显示，是否继续",
    "msga49": "是否确认要移除包码",
    "msga50": "不在当前发放计划中",
    "msga51": "请插入CA来识别审核人",
    "msga52": "请选择证书",
    "msga53": "已取消发放",
    "msga54": "请选择自动检库计划",
    "msga55": "库存不足",
    "msga56": "当前列表中没有加急器械包",
    "msga57": "没有可取消发放的计划",
    "msga58": "会将当前勾选并没用包码的行取消发放计划，是否继续",
    "msga59": "有加急器械包等待发放！",
    "msga60": "请扫描发放人",
    "msga61": "请填写或扫描下送人",
    "msga62": "是否精确查找",
    "msga63": "全部外来器械",
    "msga64": "过期物品清库记录",
    "msga65": "不合格登记记录",
    "msga66": "供应室包计数",
    "msga67": "发放不合格登记",
    "msga68": "过期物品清库",
    "msga69": "科室退库",
    "msga70": "该包已存在",
    "msga71": "发放科室选择为手术室，禁止物品出库",
    "msga72": "请选择问题登记类型",
    "msga73": "请输入包码并回车",
    "msga74": "回收发放对照",
    "msga75": "器械包数量合计",
    "msga76": "请输入接收人！",
    "msga77": "该批次所有的包将接收入库",
    "msga78": "扫描审核的包将接收入库",
    "msga79": "请输入接收人",
    "msga80": "没有可接收的包",
    "mage81": "未能识别的码",
    "mage82": "该包尚未扫码",
    "mage83": "当前列表不能为空",
    "msga84": "请输入包码或发放码，然后回车",
    "msga85": "接收人不可为空",
    "msga86": "已经将重复的包进行了过滤",
    "msga87": "选择退回原因",
    "msga88": "请选择退库原因",
    "msga89": "请选择退库器械包",
    "msga90": "选择转让手术间",
    "msga91": "请从下面科室中选择一个进行保存，取消将以",
    "msga92": "进行保存。",
    "msga93": "登记人不能为空",
    "msga94": "病人码不能为空",
    "msga95": "手术时间不能为空",
    "msga96": "分配时间",
    "msga97": "病人姓名不能为空",
    "msga98": "该包已被缓存, 禁止再次登记",
    "msga99": "该包已被缓存，是否再次登记进行覆盖?",
    "msgb1": "该包已有其他病人信息登记，是否再次登记进行覆盖?",
    "msgb2": "手术时间被调整为当前时间",
    "msgb3": "请扫描或输入",
    "msgb4": "请完善必填信息",
    "msgb5": "请选择科室后保存",
    "msgb6": "外来器械病人信息不符，请注意确认",
    "msgb7": "外来器械病人信息不符",
    "msgb8": "的灭菌时间比手术时间晚，禁止登记",
    "msgb9": "请选择手术间",
    "msgb10": "转让成功",
    "msgb11": "退库成功",
    "msgb12": "请选择退库物品",
    "msgb13": "确认保存吗？",
    "msgb14": "禁止提交申请",
    "msgb15": "强制按选择的处理中心申请",
    "msgb16": "没有可复制的包",
    "msgb17": "是否确定撤销？",
    "msgb18": "当前选择的不是默认申请供应室, 是否进行切换?",
    "msgb19": "该包已存在列表中",
    "msgb20": "未找到该推车码",
    "msgb21": "将会覆盖当前列表，确定继续吗？",
    "msgb22": "模版内没有可用的包",
    "msgb23": "当前列表中存在重复的数据，需要合并吗？",
    "msgb24": "该包无法申请或已被申请",
    "msgb25": "系统会将申请全部发送给",
    "msgb26": "列表中存在重复的数据，需要合并吗？",
    "msgb27": "申请人不可为空",
    "msgb28": "申请列表不可为空",
    "msgb29": "批次不可为空",
    "msgb30": "请选择需要提交的包",
    "msgb31": "系统会根据所属处理中心将申请分别给不同供应室，是否继续?",
    "msgb32": "请插入CA来识别审核人",
    "msgb33": "请先进行申请单打印配置（字典248）",
    "msgb34": "请勾选要加急的物品",
    "msgb35": "请选择器械包",
    "msgb36": "请勾选要删除的器械包",
    "msgb37": "是否确定删除？",
    "msgb38": "科室借包记录",
    "msgb39": "已使用包记录",
    "msgb40": "请选择要添加的包",
    "msgb41": "没有可添加的包",
    "msgb42": "发放申请记录",
    "msgb43": "申请发放不一致",
    "msgb44": "列表中当前列表中存在重复的数据，需要合并吗？",
    "msgb45": "确认取消吗?",
    "msgb46": "是否将该病人的所有包解除使用绑定？",
    "msgb47": "质控问题登记",
    "msgb48": "器械清洗不合格",
    "msgb49": "器械完整性不合格",
    "msgb55": "该包没有器械无法登记",
    "msgb58": "无菌物品发放不合格登记",
    "msgb60": "请选择设备后再操作",
    "msgb61": "请选择灭菌日期后再操作",
    "successfullyAdded": "补录成功",
    "isSureToReturn": "是否确定退回",
    "prompt": "该包是无码器械包可直接回收",
    "promptone": "存在包的数量大于",
    "prompttwo": "确认完成清点吗？",
    "promptthree": "请选择完成清点的器械包",
    "prompt1": "扫码存在问题，请检查输入法的中英模式或大小写。",
    "prompt2": "获取包信息失败",
    "prompt3": "请先扫描器械udi或标记问题",
    "prompt4": "缺少回收信息, 请重新扫码添加",
    "prompt5": "未识别的包码",
    "prompt6": "请先勾选包",
    "prompt7": "请选择要回收的包",
    "prompt8": "名称或规格不可重复",
    "prompt9": "该码中的包都已经存在，是否继续添加？",
    "prompt10": "厂家不在效期内",
    "error1": "请先选择厂家",
    "error2": "请配置字典372，否则外来器械名称将无法显示",
    "error3": "请填写器械包名称",
    "error4": "请正确填写数量",
    "error5": "该包不允许包装",
    "deleted": "删除成功",
    "deactivated": "停用成功",
    "Import": "导入成功",
    "deactivat": "确认停用吗？",
    "required": "请填写必填项",
    "permissions": "请选择权限",
    "Successfullymodified": "修改成功",
    "Successfullyadded": "新增成功",
    "Operationsuccessful": "操作成功",
    "Pleashospitalarea": "请填写院区名称",
    "switchdevice": "确认转为器械吗？",
    "Successfullydevice": "转为器械成功",
    "Successfullyconsumables": "转为耗材成功",
    "devicename": "请输入器械",
    "duplicated": "规格型号不能重复",
    "UDIinformation": "请完善UDI信息",
    "greaterthan": "器械件数要大于0",
    "packagename": "请先输入器械包",
    "enterconsumables": "请输入耗材",
    "basicunit": "请填写基本单位",
    "programname": "请填写程序名称",
    "Onlydefault": "只能设置一个默认程序",
    "informationfirst": "请先保存基本信息",
    "Successfullysaved": "保存成功",
    "Errorlabel": "标签内容解析出错",
    "Contentempty": "内容为空",
    "conversionerror": "标签内容转换出错",
    "Pleasehospitaldepartment": "请选择医院/科室",
    "addconsumptionpackage": "请添加代消包",
    "Addedsuccessfully": "添加成功",
    "selecthospitalfirst": "请先选择院区",
    "Norecyclableitems": "没有可回收的物品",
    "packagenormal": "该包正常",
    "notapplied": "该包科室未申请",
    "entercode": "请输入正确的码",
    "selectbatch": "请选择批次",
    "Inventorycompleted": "已完成清点",
    "Allcleared": "已全部清除",
    "updatesuccess": "更新成功",
    "Registrationsuccessful": "登记成功",
    "recycleditemsempty": "回收物品列表为空",
    "selectdepartment": "请选择科室",
    "Pleaseadd": "请输入想加入的文本",
    "Pleaseenter": "请输入想搜索的属性",
    "Pleaseimage": "请选择图片",
    "Nocamera": "没有开启摄像头权限或浏览器版本不兼容",
    "takephotofirst": "请先拍照",
    "selectfile": "请选择文件",
    "supportedtypes": "请选择文件并上传，支持的类型为",
    "handoversupplyroom": "请选择交接供应室",
    "continueprinting": "该标签已打印，是否继续打印",
    "Pleasereplacement": "请选择补打原因",
    "GeneratingQRcode": "生成二维码中",
    "Personnelduplicated": "人员不能重复",
    "Pleasepotnumber": "请填写锅号和锅次",
    "Pleasepackagecode": "请输入包码",
    "Pleaseselectdata": "请选择数据",
    "rollback": "确定回退吗？",
    "Fallbacksuccessful": "回退成功",
    "Packageonly": "包只能添加一次",
    "cacheablepackages": "没有可缓存的包",
    "Pleasenumber": "请选择标签号",
    "Pleasepackagingperson": "请扫描包装人",
    "Pleasereviewer": "请扫描审核人",
    "recoverysuccessful": "恢复成功",
    "Personnelnotexist": "人员不存在",
    "Pleasewait": "该包暂不能组配，请稍后",
    "Queryinformationframe": "查询时间范围内，完成回收清点的器械包信息和数量",
    "Queryinformationframe1": "查询时间范围内，按回收科室统计，完成回收清点的器械包总量",
    "Queryinformationframe2": "查询时间范围内，执行并完成清洗流程的清洗设备的运行信息和参数，以及处理的器械包信息",
    "Queryinformationframe3": "查询时间范围内，执行并完成灭菌流程的灭菌设备的运行信息和参数，以及处理的器械包",
    "Queryinformationframe4": "查询时间范围内，完成发放的器械包信息和数量",
    "Queryinformationframe5": "查询时间范围内，按发放科室统计，完成发放的器械包总量",
    "Queryinformationframe6": "以自然月为单位，按发放科室统计，供应中心完成CSSD流程处理的不同包装规格的器械",
    "Queryinformationframe7": "以自然年为单位，按发放科室统计，供应中心完成CSSD流程处理的器械包总量和处理费用总金额",
    "NumberExceed": "超出数量限制",
    "packagereturn": "该包已有科室接受记录，是否将包退回？",
    "secondIssueRightMsg1": "存在已扫码数量未达标的数据，疑似少发，是否继续",
    "secondIssueRightMsg2": "未达到实际回收的数量，请检查扫码后再重试",
    "secondIssueRightMsg3": "未达到发放申请的数量，请检查扫码后再重试",
    "secondIssueRightMsg4": "未达到包装批次的数量，请检查扫码后再重试",
    "secondIssueRightMsg5": "请选择灭菌器和日期后选择锅次"
  },
  "common": {
    "drag": "将文件拖到此处",
    "download": "下载模板",
    "full": "全",
    "lifetime": "可使用次数",
    "action": "操作",
    "list": "列表",
    "longTerm": "长租",
    "shortTerm": "短租",
    "loangear": "外来器械",
    "disable": "禁用",
    "enable": "启用",
    "baseOn": "以",
    "applicationform": "发放申请为准",
    "bundle": "捆绑",
    "postponed": "延时",
    "expirydate": "效期",
    "accounting": "核算",
    "detail": "内容",
    "countable": "计数",
    "section": "明细",
    "include": "是否有",
    "before": "前",
    "after": "后",
    "employee": "人员",
    "sterilizer": "灭菌器",
    "ID": "ID",
    "startdate": "开始日期",
    "enddate": "结束日期",
    "form": "清单",
    "cache": "暂存",
    "completed": "完成",
    "approver": "审核人",
    "limmit": "限制",
    "empty": "清空",
    "if": "是否",
    "to": "至",
    "ItemSummary": "物品汇总",
    "selected": "选中",
    "Later": "稍后",
    "retrace": "追溯",
    "procedure": "过程",
    "result": "结果",
    "Qualityinspector": "质检人",
    "Secondqualityinspector": "第二质检人",
    "Accuratesearch": "精确查找",
    "Pipelinenode": "流水线节点",
    "Earlyrelease": "提前放行",
    "Selfuse": "自用",
    "expire": "过期",
    "location": "使用地点",
    "washer": "清洗设备",
    "program": "程序",
    "msg": "请选择需要交接的包",
    "msg1": "没有可打印的数据",
    "msg2": "无菌库有",
    "msg3": "件包过期，是否立刻处理？",
    "msg4": "请选择需要导出的物品",
    "msg5": "请选择需要发放的物品",
    "msg6": "查询流程时间范围交集内，器械包的处理流程信息",
    "msg7": "请完善信息",
    "msg8": "请选择已有的包",
    "msg9": "没有可打印的包",
    "msg10": "您有未扫码的器械，是否继续？",
    "msg11": "确认清除吗？"
  },
  "recycle": {
    "input": "输入",
    "id": "ID",
    "current": "清点",
    "statisList": "新增器械包统计",
    "approved": "审核",
    "Returnpackage": "还包",
    "loan": "外来器械",
    "daixiao": "代消",
    "rec": "回收",
    "applyVariance": "申请差异记录",
    "infect": "感染",
    "urgent": "加急",
    "level": "级别",
    "small_infect": "感染",
    "summary": "统计",
    "from": "开始时间",
    "to": "结束时间",
    "quantity": "数量",
    "recycled": "已回收",
    "borrowed": "借包",
    "info": "Info.",
    "srg": "手术",
    "right": "正常",
    "inventory": "库存",
    "before": "前",
    "after": "后",
    "qty": "拆卸",
    "process": "流程",
    "operator": "清点人",
    "used": "使用"
  },
  "empty": {
    "moniker": "姓名不能为空",
    "account": "登录账号不能为空",
    "password": "密码不能为空",
    "jobNumber": "工号不能为空",
    "department": "科室不能为空",
    "scopework": "工作范围不能为空",
    "post": "岗位不能为空",
    "types": "类型不能为空",
    "Courtyard": "院区不能为空",
    "DepartmentGroup": "科室组不能为空",
    "center": "处理中心不能为空",
    "head": "负责人不能为空",
    "number": "账号不能为空",
    "Device": "名称不能为空",
    "Standard": "标准名称不能为空",
    "consumable": "耗材名称不能为空",
    "packageempty": "器械包不能为空",
    "returntimeempty": "还包时间不能为空",
    "Recyclerempty": "回收人不能为空",
    "Countingempty": "清点人不能为空",
    "Manufacturerempty": "厂家不能为空",
    "Supplierempty": "供应商不能为空",
    "surgicadepartmentempty": "手术科室不能为空",
    "deliverempty": "送货人不能为空",
    "Wardempty": "病区不能为空",
    "replacementpersonempty": "补打人不能为空",
    "Sterilizerempty": "灭菌人不能为空",
    "packagingpersonempty": "包装人或组配人不能为空",
    "Reviewerblank": "审核人不能为空",
    "cannotbeempty": "包装材料、灭菌方式和效期都不能为空",
    "departmentamountexportbeempty": "科室金额导出时间不能为空",
    "questiontypeempty": "问题类型不能为空",
    "Partcannotempty": "部位不能为空"
  },
  "all": {
    "account": "登录账号",
    "nodata": "暂无数据",
    "personnel": "人员管理",
    "Pinformation": "人员信息",
    "authority": "权限",
    "PersonalData": "个人信息",
    "certificate": "证书",
    "Userlogin": "用户登录信息",
    "scopework": "工作范围",
    "Accountstatus": "账号状态",
    "Endoscopic": "内镜工号",
    "role": "角色",
    "Menupermissions": "菜单权限",
    "Buttonpermissions": "按钮权限",
    "Setavatar": "设置头像",
    "Basicinformation": "基本信息",
    "IDcard": "身份证",
    "nation": "民族",
    "Politicaloutlook": "政治面貌",
    "datebirth": "出生日期",
    "Hobbies": "爱好特长",
    "WorkInformation": "工作信息",
    "position": "职位",
    "Nurselevel": "护士能级",
    "entrytime": "入职时间",
    "Timeresignation": "离职时间",
    "mobilephone": "手机",
    "Homephone": "家庭电话",
    "emergencycontact": "紧急联系人",
    "Emergencycall": "紧急电话",
    "email": "邮箱",
    "address": "地址",
    "filename": "文件名",
    "blank": "空白",
    "AddCenter": "添加处理中心",
    "AddCampus": "添加院区",
    "Synchronizedata": "同步数据",
    "Newgroup": "新建科室组",
    "Parentdepartment": "父级科室",
    "head": "负责人",
    "Expiration": "无菌库过期小时数",
    "floor": "楼层",
    "Unrestricted": "不限制申请",
    "registeruse": "是否需要做使用登记",
    "Blockexpiredpackages": "屏蔽过期包",
    "HISDepartment": "HIS系统科室",
    "HIScode": "HIS系统科室代码",
    "MaterialDepartment": "物资系统科室",
    "Materialcode": "物资系统科室代码",
    "DistributionPlan": "发放计划",
    "packagingbatch": "按包装批次",
    "distributionapplication": "按发放申请",
    "vehicle": "下送车",
    "zhanghao": "账号",
    "departmentmanagement": "科室管理",
    "Newdepartment": "新建科室",
    "EditingDepartment": "编辑科室",
    "Editdepartmentgroup": "编辑科室组",
    "ConsumableManagement": "耗材管理",
    "Allconsumables": "全部耗材",
    "DeviceManagement": "器械管理",
    "fullname": "全名称",
    "Devicebound": "已绑定器械",
    "Packagingmethod": "包装方式",
    "Handlingmethod": "处理方式",
    "InventoryLocation": "库存位置",
    "Importcardinality": "导入基数",
    "ExportManifest": "导出清单",
    "Exportengravingpackage": "导出刻码包",
    "PageEditing": "页面编辑",
    "Devicepackagemanagement": "器械包管理",
    "Inventorypackagestatistics": "库存包统计",
    "Isdevice": "是否外来器械",
    "corporatename": "公司名称",
    "FixedDetails": "是否固定明细",
    "Centralizednot": "是否集采",
    "Specialitems": "特殊物品",
    "labelprinting": "标签打印",
    "Bundledprinting": "捆绑打印",
    "distributiondelay": "自动发放延时",
    "distri": "以发放申请为准",
    "Numberimplants": "植入物数量",
    "Automaticallyperiod": "自动关联效期",
    "Sterilizationvalidity": "灭菌有效期",
    "Disinfectionvalidity": "消毒有效期",
    "Multiplesterilization": "多重灭菌",
    "cleaningmethod": "清洗方式",
    "Sterilizationfee": "灭菌费",
    "Otherfee": "其他费用",
    "Cleaningfee": "清洗费",
    "packagingfee": "检查包装费",
    "Distributionfee": "发放费",
    "costamount": "成本金额",
    "settlement": "结算金额",
    "newapplyfor": "新申请费",
    "AlertInventory": "预警库存",
    "Numberdevices": "器械件数",
    "Numberconsumables": "耗材件数",
    "Numbercomponents": "配组件数",
    "Locationencoding": "位置编码",
    "PropertyOwnership": "财产归属科室",
    "Costaccounting": "成本核算类型",
    "foreignpackage": "外来器械包类名",
    "Packagingprecautions": "配包注意事项",
    "Recyclingprecautions": "回收注意事项",
    "Cleaningprecautions": "清洗注意事项",
    "Sterilizationprecautions": "灭菌注意事项",
    "Distributionprecautions": "发放注意事项",
    "Packageengravingcode": "包刻码",
    "Creationtime": "创建时间",
    "Automaticupdate": "自动更新",
    "Beforedisassembly": "拆卸前",
    "Afterdisassembly": "拆卸后",
    "otherImplants": "其他植入物",
    "nootherImplants": "其他非植入物",
    "Details": "固定明细",
    "DeviceDetails": "器械明细",
    "ConsumableDetails": "耗材明细",
    "Recycler": "回收人",
    "PackagingSpecifications": "包装规格",
    "ExternalDeviceType": "外来器械类型",
    "TotalEquipmentPackage": "器械包总计",
    "ItemsToBeClassified": "待分类物品",
    "BatchDeletion": "批量删除",
    "BatchSupplementaryRecording": "批量补录",
    "HandoverOfItems": "物品交接",
    "BatchReturn": "批量退回",
    "BasketCode": "篮筐码",
    "BatchSelection": "批量选中",
    "CourtyardHandover": "院区交接",
    "Retreat": "退",
    "ThereAreDeviceIssues": "存在器械问题",
    "SupplementaryRecording": "补录",
    "return3": "退回",
    "BatchPreprocessing": "批量预处理",
    "CleaningPreTreatmentPersonnel": "清洗预处理人",
    "ScanPersonnelCode": "扫描人员码",
    "Preprocessing": "预处理",
    "DateFiltering": "日期筛选",
    "DevicePackageName": "器械包名称",
    "Preprocessor": "预处理人",
    "TotalNumberOfItems": "物品总数",
    "Confirm": "确定",
    "FinishedSortingItems": "已分类完成物品",
    "PreprocessingMethod": "预处理方式",
    "ShortTermRentalOfForeignEquipment": "短租外来器械",
    "LongTermRentalOfExternalEquipment": "长租外来器械",
    "number": "编号",
    "Distributors": "经销厂家",
    "Numberalerts": "预警数量",
    "Basicunit": "基本单位",
    "Units": "单位换算",
    "equipmentmanagement": "设备管理",
    "price": "价格",
    "Life": "使用年限",
    "Sterilizationmethod": "灭菌方式",
    "Biologicaltime": "生物检测时间",
    "contacts": "联系人",
    "Telephone": "联系电话",
    "mobile": "移动电话",
    "Firstusetime": "初次使用时间",
    "Equipmentperson": "设备责任人",
    "Departmentperson": "科室责任人",
    "Specificationmodel": "规格型号",
    "Qualityequipmenttype": "质控设备类型",
    "Qualitysterilizationtype": "质控灭菌类型",
    "operatingcost": "运行费用",
    "yuan": "元",
    "zeroclearing": "锅次每天清零",
    "prohibit": "灭菌器禁止不同灭菌方式的包",
    "Biologicalrequired": "每锅需要做生物监测",
    "Runprinting": "运行打印",
    "Endcalibration": "结束校准",
    "duration": "时长",
    "BD": "BD",
    "leakhunting": "测漏",
    "Emptyoperation": "空锅运行",
    "Sideinspectiontime": "测漏程序检验时间",
    "Defaultbiological": "默认生物监测",
    "Biologicalfrequency": "生物监测频率",
    "shelvingdata": "强制空锅并保留原有上架数据",
    "first": "首次",
    "everytime": "每次",
    "ReasonForSupplementaryRecording": "补录原因",
    "ItemsToBeCleanedAndDisinfected": "待清洗消毒物品",
    "BlueBasketName": "蓝筐名称",
    "stepByStepCleaning": "分步清洗",
    "integratedMachineCleaning": "一体机清洗",
    "utensils": "器皿",
    "cleaningMachineOperationStatus": "清洗机运行情况",
    "equipmentRegistrationRecords": "设备登记记录",
    "itemName": "物品名称",
    "reCleaning": "重新清洗",
    "startCleaning": "开始清洗",
    "disinfectionMethod": "消毒方式",
    "dryingMethod": "干燥方式",
    "cleaningPersonnel": "清洗人",
    "pleaseScanTheCleaner": "请扫描清洗人",
    "pleaseScanTheCleaningRack": "请扫描清洗架",
    "cleaningRack": "清洗架",
    "cleaningProgram": "清洗程序",
    "whetherToManuallyFillThePot": "手填锅次",
    "cleaningPotTimes": "清洗锅次",
    "Loadingequipment": "装载用具",
    "Loadingtoolmanagement": "装载用具管理",
    "Warehouse": "所属库房",
    "Batchprint": "批量打印",
    "repeatScan": "重复扫描",
    "tagname": "标签名称",
    "test": "测试",
    "prompt": "提示",
    "goRegister": "去登记",
    "registrationOfCleaningEquipment": "清洗设备登记",
    "sterilizationEquipmentName1": "灭菌设备名称1",
    "clean1": "洁净",
    "noClean1": "不洁净",
    "abnormal": "不正常",
    "adequate": "充足",
    "insufficient": "不充足",
    "fault": "故障",
    "noFaults": "无故障",
    "unobstructed": "通畅",
    "notUnobstructed": "不通畅",
    "PHValue": "PH值",
    "enzymeAdditionAmount": "加酶量（ml）",
    "addLubricatingOil": "加润滑油（ml）",
    "purifiedWaterPressure": "纯化水压力（0.3Mpa）",
    "compressedAir": "压缩空气（0.4-0.6MPa）",
    "salt": "盐(公斤)",
    "can": "能",
    "cannot": "不能",
    "block": "阻塞",
    "noBlocking": "无阻塞",
    "Preview": "预览",
    "Totalpackages": "总包数",
    "equipmentMaintenanceRecords": "设备维护记录",
    "registrationTime": "登记时间",
    "registrationArea": "登记区域",
    "deviceName": "设备名称",
    "itemsToBeSterilized": "待灭菌物品",
    "addCurrentSterilizer": "加入当前灭菌器",
    "packagingDate": "包装日期",
    "sterilizationDate": "灭菌日期",
    "packageCode": "包码",
    "registrationOfUnqualifiedPackaging": "包装不合格登记",
    "registrationOfDeviceIssues": "器械问题登记",
    "sterilizationAndShelving": "灭菌及上架",
    "selectSterilizerAndSterilizationRack": "选择灭菌器及灭菌架",
    "sterilizerStatus": "灭菌器状态",
    "overallCodeListing": "总码上架",
    "totalCodeRemoval": "总码下架",
    "biologicalMonitoringTime": "生物监测时间",
    "biologicalMonitoringReasons": "生物监测原因",
    "currentSterilizer": "当前灭菌器",
    "currentSterilizationRack": "当前灭菌架",
    "loaded": "已装载",
    "packages": "个包",
    "departmentName": "科室名称",
    "groupName": "分组名称",
    "preservationOfBiologicalMonitoringMarkers": "生物监测标记保存",
    "startSterilization": "开始灭菌",
    "inputCorrection": "输入更正",
    "importOtherSterilizers": "导入其他灭菌器",
    "abnormalDeviceIssues": "设备异常问题",
    "packetCount": "包计数",
    "sterilizationRack": "灭菌架",
    "pleaseScanTheSterilizationRack": "请扫描灭菌架",
    "sterilizationProcedure": "灭菌程序",
    "currentlyNoProgram": "暂无程序",
    "sterilizationPotNumber": "灭菌锅次",
    "sign": "标记",
    "testPackageCode": "测试包码",
    "reasonForDeletion": "删除原因",
    "uploadAttachments": "上传附件",
    "Packagestatistics": "包统计",
    "Recyclingrecords": "回收审核记录",
    "ReturnRecord": "还包记录",
    "Outsourcingpackage": "代消包",
    "Allinstrumentpacks": "全部器械包",
    "Usingunrecycled": "使用未回收器械",
    "Pleasecode": "请扫描人员码",
    "Receiver": "下收人",
    "Printdocuments": "打印回收单据",
    "Urgentlevel": "加急级别",
    "Infectiontype": "感染类型",
    "Unreturnedquantity": "未归还数量",
    "Supplementaryaddition": "补充新增",
    "Registrationissues": "器械问题登记",
    "usageinformation": "使用信息",
    "Completeinventory": "完成清点",
    "clearall": "全部清除",
    "Excesspieces": "多余器械和件数",
    "Lackquantity": "缺少器械和件数",
    "Returntime": "归还时间",
    "Returnquantity": "归还数量",
    "borrowedpackages": "借包数量",
    "Distributiontime": "发放时间",
    "Issuedby": "发放人",
    "recipient": "接收人",
    "Returnregistration": "还包登记",
    "Returntime1": "还包时间",
    "Returnquantity1": "还包数量",
    "Proxyreception": "代消包接收",
    "packaging": "包装材料",
    "Addrecyclinglist": "加入回收列表",
    "Manualrecycling": "手动回收物品",
    "Recyclingtemplates": "回收模板",
    "Blockdepartments": "屏蔽无关科室",
    "RecyclingDepartment": "回收科室",
    "Binddepartments": "绑定科室",
    "Basicmaintenance": "基础数据维护",
    "warn": "警告",
    "DateTime": "日期时间",
    "Auditcode": "审核码",
    "operationroom": "手术间",
    "Recyclingstatus": "回收状态",
    "hiddenstate": "隐藏状态",
    "Packagingstatus": "打包状态",
    "Applicationdepartment": "申请科室",
    "time": "申请时间",
    "ApplicationNotes": "申请备注",
    "Quantity": "申请数量",
    "Recycledquantity": "已回收数量",
    "Totaldepartmentapplications": "科室申请数量总和",
    "Recyclingtime": "回收时间",
    "Demandtime": "需求时间",
    "Oneclickpackaging": "一键打包",
    "Dressingbag": "敷料包",
    "registrant": "登记人",
    "singlePot": "单锅",
    "pleaseSelectAPackage": "请选择包",
    "sterilizationEquipmentRegistration": "灭菌设备登记",
    "sterilizationEquipment": "灭菌设备",
    "faulty": "有故障",
    "pressureReducingValve": "减压阀",
    "innerChamberPressure": "内室压力（0）",
    "interlayerPressure": "夹层压力（-0.1）",
    "tapWater": "自来水（0.15-0.3MPa）",
    "compressedAir1": "压缩空气（0.4-0.7MPa）",
    "exhaustPort": "排气口",
    "cabinetDoor": "柜门",
    "wordsize": "字号",
    "Rowheight": "行高",
    "Bold": "粗体",
    "alignment": "对齐",
    "theleft": "左边",
    "Center": "居中",
    "theright": "右边",
    "Inversecolor": "反色",
    "remove": "移除",
    "Labelsize": "标签尺寸",
    "meshsize": "网格尺寸",
    "scaling": "缩放比例",
    "ExitFullScreen": "退出全屏",
    "text": "文本",
    "QRcode": "二维码",
    "barcode": "条形码",
    "DMcode": "DM码",
    "pixelsize": "像素尺寸",
    "Duringfilming": "拍摄中",
    "Multiplefileupload": "多文件上传",
    "fileupload": "文件上传",
    "serialNumber": "序号",
    "unqualifiedCleaning": "清洗不合格",
    "uploadPhotos": "上传照片",
    "earlyEnd": "提前结束",
    "finish": "结束",
    "qualified": "合格",
    "fallbackAll": "全部回退",
    "operatingParameters": "运行参数",
    "pleaseScanTheQualityInspector": "请扫描质检人",
    "cleaningTime": "清洗时间",
    "selectDateTime": "选择日期时间",
    "inspectionMethod": "检查方法",
    "unqualifiedQuantity": "不合格数量",
    "descriptiveText": "描述文字",
    "HandoverSupplyRoom": "交接供应室",
    "continue": "继续",
    "sterilizationQualityInspection": "灭菌质检",
    "randomInspectionOfSterilizationQuality": "灭菌质量抽查",
    "unqualified": "不合格",
    "sterilizationStartDate": "灭菌开始日期",
    "monitoringStartDate": "监测开始日期",
    "monitoringEndDate": "监测结束日期",
    "earlyReleaseStatus": "提前放行状态",
    "biologicalMonitoringResults": "生物监测结果",
    "reasonForEarlyRelease": "提前放行原因",
    "earlyReleaseTime": "提前放行时间",
    "earlyReleaseOfPedestrians": "提前放行人",
    "advanceReleasePackageNotificationTime": "提前放行包通报时间",
    "selectDate": "选择日期",
    "notifyTheExecutor": "通报执行人",
    "notificationDepartment": "通报科室",
    "released": "已放行",
    "saveEdit": "保存编辑",
    "pleaseScan": "请扫描",
    "first1": "第一",
    "reasonForNonconformity": "不合格原因",
    "submit": "提交",
    "returnTo": "退回至",
    "checkedBy": "抽查人",
    "placementLayer": "摆放层：",
    "placementPosition": "摆放位置",
    "placementMethod": "摆放方式",
    "spotCheckResults": "抽查结果",
    "Totalbeforedisassembly": "拆卸前总数",
    "Totalafterdisassembly": "拆卸后总数",
    "Recyclingremarks": "回收备注",
    "Specialremarks": "特殊备注",
    "Totaldevices": "器械总数",
    "Totalconsumables": "耗材总数",
    "bindingdetails": "绑定明细",
    "CancelScan": "取消扫描",
    "VideoPreview": "视频预览",
    "Successfullyidentified": "成功识别",
    "Pieceequipment": "件器械",
    "Pieceexcessequipment": "件多余器械，请确认",
    "Registrationdevices": "外来器械登记",
    "Receivinginformation": "接收信息",
    "Patientinformation": "病人信息",
    "Patientname": "病人姓名",
    "surgicaldepartment": "手术科室",
    "Affiliatedhospitalarea": "所属院区",
    "DateOperation": "手术日期",
    "Surgicalname": "手术名称",
    "deviceinformation": "外来器械信息",
    "taglist": "标签列表",
    "Bundlelabels": "捆绑标签",
    "Batchcode": "批次码",
    "Supplementarysorting": "补打排序",
    "Totalcodeprinting": "总码打印",
    "Supplementaryprinting": "包明细补打",
    "Labelmodification": "标签信息修改",
    "sterilizationtime": "灭菌时间",
    "perioddays": "实际计算效期为天数",
    "Packager": "包装人",
    "Matchingperson": "组配人",
    "Sterilizer": "灭菌人",
    "supplementaryprinting": "补打原因",
    "makesomeone": "补打人",
    "Bundlelabelcode": "捆绑标签码",
    "DeleteArchive": "删除归档",
    "consumptionagency": "院内代消",
    "OutsourcedAgency": "院外代消",
    "Deliverer": "送物人",
    "HideFilterItems": "隐藏筛选项",
    "ShowFilterItems": "显示筛选项",
    "Recyclingdepartmentcategory": "回收科室类别",
    "Classes": "包类别",
    "DirectCost": "直接成本核算",
    "Cleaningqualitytime": "清洗质检时间",
    "Othercourtyarditems": "其他院区物品",
    "SelectPrintAll": "全选打印",
    "Selectcombinations": "全选组配",
    "BatchPrintList": "批量打印清单",
    "Printbasketlist": "篮筐清单打印",
    "StagingList": "暂存列表",
    "DressingPackageView": "敷料包查看",
    "Completionassembly": "组配完成",
    "PrintRecord": "标签打印记录",
    "Documentprinting": "单据打印",
    "printlist": "打印清单",
    "releasedInAdvance": "已提前放行",
    "notReleasedInAdvance": "未提前放行",
    "unregisteredResults": "未登记结果",
    "kilogram": "千克",
    "endOfSterilization": "灭菌结束",
    "toBePackaged": "待包装",
    "spotCheckTime": "抽查时间",
    "documentProperties": "单据属性",
    "packageProperties": "包属性",
    "handleImmediately": "马上处理",
    "talkLater": "稍后再说",
    "unplannedDistribution": "计划外发放",
    "scanCode": "扫码",
    "inputCode": "输入码",
    "addToPlanList": "加入到计划列表",
    "distributionAndPreservation": "发放保存",
    "distributionRecords": "发放记录",
    "mergePrinting": "合并打印",
    "distributionStatisticsPrinting": "发放统计打印",
    "printed": "已打印",
    "departmentType": "科室类型",
    "toBeDistributed": "待发放",
    "scannedCode": "已扫码",
    "actualRecycling": "实际回收",
    "recyclingBatchCode": "回收批次码",
    "distributionApplication": "发放申请",
    "auditTime": "审核时间",
    "auditOrderCode": "审核单码",
    "issuanceOfReviewOrderCode": "发放审核单码",
    "loanApplication": "借包申请",
    "contain": "包含",
    "justCheck": "只查",
    "packagingBatch": "包装批次",
    "packagingTime": "包装时间",
    "packaginBgatchCode": "包装批次码",
    "packageType": "包类型",
    "engraveACard": "刻牌",
    "eliminate": "排除",
    "exchange": "兑换",
    "automaticWarehouseInspection": "自动检库",
    "distributionCompleted": "发放完成",
    "removePackageCode": "移除包码",
    "cancelDistribution": "取消发放",
    "packageName": "包名",
    "singleCode": "单码",
    "operationFailed": "操作失败",
    "urgentLevel": "加急等级",
    "deliveredBy": "下送人",
    "confirmDistribution": "确认发放",
    "Devicestatistics": "器械统计",
    "packagestatistics": "器械包统计",
    "Personnelstatistics": "人员统计",
    "Consumablestatistics": "耗材统计",
    "Equipmentstatistics": "设备统计",
    "DepartmentStatistics": "科室统计",
    "Supplierstatistics": "供应商统计",
    "Completedrecyclingapplication": "通过回收申请单完成",
    "ExpiredPackage": "过期包",
    "ModifyUrgentLevel": "修改加急级别",
    "Recyclingstatistics": "回收统计",
    "backforeigninstruments": "回洗外来器械",
    "Firstdevice": "首次外来器械",
    "ItemSummaryExport": "物品汇总导出",
    "Cleaningresults": "清洗结果",
    "Belongingdepartment": "归属科室",
    "Totalcleaningamount": "清洗总数",
    "departmentPackageCount": "科室包计数",
    "inventoryWarning": "库存预警",
    "returningInventory": "退库",
    "itemOutbound": "物品出库",
    "unqualifiedRegistration": "不合格登记",
    "confirmOutbound": "确认出库",
    "confirmRegistration": "确认登记",
    "sterileWarehouseReturn": "无菌库退库",
    "addToDistributionList": "加入发放列表",
    "operator": "操作人",
    "packageEncoding": "包编码",
    "warehousingTime": "入库时间",
    "expirationTime": "过期时间",
    "problemRegistration": "问题登记",
    "inventoryQuantity": "库存数量",
    "Cleaningprocess": "清洗流程",
    "timeon": "开始时间",
    "EndTime": "结束时间",
    "Sterilizationresults": "灭菌结果",
    "Sterilizationremarks": "灭菌备注",
    "Totalsterilizationcount": "灭菌总数",
    "EquipmentOperationRecordForm": "设备运行记录表",
    "Distributiondepartment": "发放科室",
    "Distributionmethod": "发放方式",
    "Stockreturn": "退库",
    "Distributionstatistics": "发放统计",
    "Sterilizationtype": "灭菌类型",
    "Packagingtype": "包装类型",
    "Itemrecall": "物品召回",
    "doesnotcontain": "不包含",
    "AmountExport": "金额导出",
    "Distributionstatisticsexport": "发放统计导出",
    "DepartmentAmountExport": "科室金额导出",
    "Totalnumberdevices": "器械数量合计",
    "Totalamount": "金额合计",
    "Instrumentpackagetraceability": "器械包追溯",
    "Itemcode": "物品编码",
    "Sterilizationbatchcode": "灭菌舱次",
    "Classnumber": "批次码",
    "Biologicalmonitoringpersonnel": "生物监测人",
    "Receptiontime": "接收时间",
    "Operatingtablenumber": "手术台号",
    "Usagetime": "使用时间",
    "Useregistrant": "使用登记人",
    "monthlyreport": "月度报表",
    "annualreport": "年度报表",
    "month": "月份",
    "Includingdevices": "包含外来器械",
    "Onlysearchdevicesnth": "仅查询外来器械",
    "nosearchdevices": "不查询外来器械",
    "year": "年份",
    "Summarizeddepartment": "按科室汇总",
    "SummarizePackageName": "按包名汇总",
    "Outsideplan": "计划外",
    "insideplan": "计划内",
    "Redemptionpackage": "兑换包",
    "Costanalysisstatistics": "成本分析统计",
    "January": "1月",
    "February": "2月",
    "March": "3月",
    "April": "4月",
    "May": "5月",
    "June": "6月",
    "July": "7月",
    "August": "8月",
    "September": "9月",
    "October": "10月",
    "November": "11月",
    "December": "12月",
    "ManualCleaning": "手工清洗",
    "receiveRecord": "接收记录",
    "sterileWarehouse": "无菌库",
    "totalReceived": "接收总数",
    "onTheSameDay": "当天",
    "detailFolding": "明细折叠",
    "expandDetails": "明细展开",
    "receivingDetails": "接收明细",
    "scanCodeReception": "扫码接收",
    "storageLocation": "存放位置",
    "wetPackageRegistration": "湿包登记",
    "auditAcceptance": "审核接收",
    "receiveAll": "全部接收",
    "summaryView": "汇总查看",
    "errorLog": "错误日志",
    "labelCode": "标签码",
    "receivingMethod": "接收方式",
    "supplyRoomReception": "供应室接收",
    "confirmReceipt": "确认接收",
    "theCurrentInventoryIs": "当前入库是",
    "difference": "差值",
    "scanErrorLog": "扫码错误日志",
    "scanCodeInputCorrection": "扫码输入更正",
    "receivedSuccessfully": "接收成功",
    "questiontype": "问题类型",
    "location": "部位",
    "Sterilizationmodification": "灭菌修改",
    "Secondinspector": "二检人",
    "anypointtime": "任意时间点",
    "sterilizationtemperature": "灭菌温度",
    "Sterilizationpressure": "灭菌压力",
    "Mainloaditems": "主要装载物品",
    "chemicalmonitoring": "化学监测",
    "Printingrecordssterilization": "灭菌过程打印记录",
    "Shielddressingbag": "屏蔽敷料包",
    "Shielddevices": "屏蔽外来器械",
    "Totalnumberrooms": "供应室总数",
    "Totalnumberdepartments": "科室总数",
    "EngravedCodeDetails": "刻码详情",
    "PackageLocation": "包位置",
    "Locationengravingpackage": "刻码包位置",
    "Locationengravingpackagecode": "刻码包位置码",
    "Engravedcode": "刻码包码",
    "TagCode": "标签码",
    "TagCoCarvingPackageNamede": "刻码包名",
    "Useregistrationstartdate": "使用登记开始日期",
    "Useregistrationenddate": "使用登记结束日期",
    "Startdaterecyclingapplication": "回收申请开始日期",
    "Enddaterecyclingapplication": "回收申请结束日期",
    "Actualrecyclingstartdate": "实际回收开始日期",
    "Actualrecyclingenddate": "实际回收结束日期",
    "Recyclingtimeoutpackets": "回收超时包",
    "Recyclingtimeoutpacketreminder": "回收超时包提醒",
    "Workarea": "工作区域",
    "decontaminationarea": "去污区",
    "Packagingarea": "打包区",
    "sterile": "无菌区",
    "JobDetails": "工作明细",
    "reportingperiod": "报告周期",
    "Reportstatisticalcaliber": "报告统计口径",
    "DepartmentRelations": "科室关系",
    "Statisticalmethods": "统计方式",
    "Flowstatistics": "流水统计",
    "Unqualifiedinspection": "未质检",
    "Sterilizationstatistics": "灭菌统计",
    "Cleaningstatistics": "清洗统计",
    "Bypackage": "按包",
    "Bynumbertimes": "按次数",
    "Hidesecondaryrecycling": "隐藏二次回收",
    "Nameforeigndevicemanufacturer": "外来器械厂家名称",
    "fuzzymatching": "模糊匹配",
    "piece": "件",
    "Recyclingcompleted": "回收完成",
    "Sterilizationcompleted": "灭菌完成",
    "Packagingcompleted": "包装完成",
    "Cleaningcompleted": "清洗完成",
    "patientAge": "病人年龄",
    "patientGender": "病人性别",
    "surgicalTime": "手术时间",
    "cacheInformation": "缓存信息",
    "queryPatientRecords": "查询病人记录",
    "operatingRoomItems": "手术间物品",
    "packagingReview": "包装审核",
    "sterilizationAudit": "灭菌审核",
    "unit": "单位",
    "dateOfBirth": "出生年月",
    "patientDepartment": "病人科室",
    "patientBedNumber": "病人床号",
    "anesthesiaSystemName": "麻醉系统名称",
    "preface": "台序",
    "operationDoctor": "操作医生",
    "doctorID": "医生工号",
    "heavyDrugResistance": "重耐药性",
    "batchReturnOfInventory": "批量退库",
    "assignment": "转让",
    "patientCode": "病人登记号",
    "before": "早于",
    "diagnosis": "诊断",
    "Sterilizationpotcode": "灭菌锅次码",
    "Potproperties": "锅次性质",
    "BDtesting": "BD测试",
    "Leaktesting": "测漏测试",
    "Physicalmonitoring": "物理监测",
    "Totalnumberbatches": "锅次总计",
    "Totaloperatingexpenses": "运行费用总计",
    "Totalcostconsumption": "单锅加消费用总计",
    "order": "次",
    "Nonsinglepot": "非单锅",
    "Emptypot": "空锅",
    "Sterilizationworkload": "灭菌工作量",
    "Displaysupplyroomdata": "显示供应室数据",
    "Displaysterilizationqualifieddata": "仅显示灭菌合格数据",
    "Cleaningworkload": "清洗工作量",
    "Displayonlyqualifiecleaningdata": "仅显示清洗合格数据",
    "Cleaningpackageworkload": "清洗包工作量",
    "Distributionvolume": "发放包工作量",
    "Earlyreleasestatistics": "提前放行统计",
    "Packagingworkload": "包装工作量",
    "PackageClassName": "包类名",
    "Statisticsreturnissues": "退库问题统计",
    "Reasonproblem": "问题原因",
    "Usagepackagecount": "使用包数统计",
    "Statisticsnumberdevicesused": "使用器械数量统计",
    "applicationTemplate": "申请模版",
    "applyForANewDeviceKit": "申请新器械包",
    "usingDirtyBags": "使用污包",
    "borrowingRecords": "借包记录",
    "whetherRoReturnThePackage": "是否还包",
    "applicant": "申请人",
    "applicationRecord": "申请记录",
    "blockIrrelevantItems": "屏蔽无关物品",
    "inconsistentRecyclingApplication": "申请回收不一致",
    "recyclingQuantity": "回收数量",
    "reasonForRejection": "驳回理由",
    "revoke": "撤销",
    "increaseQuantity": "增加数量",
    "borrowingTime": "借包时间",
    "borrower": "借包人",
    "handWashingPeople": "手洗人",
    "successfullyStaged": "暂存成功",
    "successfullySubmitted": "提交成功",
    "recyclingApplicationRecord": "回收申请记录",
    "usageType": "使用类型",
    "patientName": "患者名",
    "selfUseRecords": "自用记录",
    "expiredEntries": "过期记录",
    "patientRecords": "病人记录",
    "Allocatedcostaccounting": "分摊成本核算",
    "CostItemSetting": "成本项目设定",
    "costitem": "成本项",
    "DefaultCost": "默认成本(元)",
    "open": "打开",
    "Foundationcoefficient": "基础系数",
    "count": "计算",
    "Disinfectionbagcategory": "消毒包类别",
    "completedpackages": "完成包数(个)",
    "Convertbasicworkload": "换算基础工作量",
    "Disinfectionadditionalcosts": "消毒附加成本（元/个）",
    "Costconsumables": "各类低值耗材成本（元/个）",
    "Depreciationpackaging": "各类包装折旧成本（元/个）",
    "Pricingdisinfectionpackages": "各类消毒包核价（元/个）",
    "Incomedisinfectionpackagepricing": "消毒包核价收入（元）",
    "CostRunchart": "成本趋势图",
    "Totalmonthlydisinfectionpackageaudit": "合计月消毒包核价收入（元）",
    "Totalmonthlytotalcost": "合计月总成本（元）",
    "Totalmonthlydisinfection": "合计月消毒包核价收入（元）",
    "disinfectionpackageconsumables": "消毒包耗材成本率",
    "consumableApplication": "耗材申请",
    "isBorrowBagOrNot": "借包",
    "applicationDate": "申请日期",
    "issuedQuantity": "已发放数量",
    "ageUnit": "年龄单位",
    "cancelRecordQuery": "取消记录查询",
    "recordExport": "记录导出",
    "exportTotalItems": "物品合计导出",
    "cancelUse": "取消使用",
    "preoperative": "术前",
    "postoperative": "术后",
    "preoperativeRegistration": "术前登记",
    "postoperativeRegistration": "术后登记",
    "postoperativePreservation": "保存术后",
    "canceledSuccessfully": "取消成功",
    "cancelRecord": "取消记录",
    "pleaseSelectADate": "请选择日期",
    "Converttoequipment": "转为器械",
    "Converttoconsumables": "转为耗材",
    "departmentFilter": "科室筛选",
    "scanCodeStatus": "扫码状态",
    "shieldOtherScanCodePack": "屏蔽其他人扫的包",
    "onselfScanCode": "自己扫的包",
    "targetState": "达标状态",
    "scanNoQualified": "已扫码未达标",
    "scanQualified": "已扫码达标",
    "noScan": "未扫码",
    "scanCollectStatistics": "扫码汇总统计",
    "inspectionType": "检查类型",
    "timeOfOccurrence": "发生时间",
    "monitoringMethod": "监测方式",
    "unqualifiedType": "不合格类型",
    "deviceName1": "器械名称",
    "deviceType": "器械类型",
    "inspector": "检验人",
    "initialInspector": "初检人",
    "reviewedBy": "复检人",
    "scheduling": "排班",
    "workingHours": "工作时间",
    "teamLeaderRandomInspection": "组长抽查",
    "nurseSpotCheck": "护士抽查",
    "qualityController": "质控人",
    "qualityInspectionParty": "质检方",
    "whole": "整体",
    "packOptionUnquality": "包装材料不合格",
    "packSignUnquality": "包装标识不合格",
    "packComplete": "包装完整性",
    "discoverer": "发现方",
    "wetPackageTypes": "湿包类别",
    "reasonForSteriAndSteam": "灭菌器及蒸汽原因",
    "loadCapcity": "装载容量",
    "loadPlaceMethod": "装载摆放方法",
    "packElastic": "包装松紧度",
    "coolTime": "冷却时间",
    "minute": "分钟",
    "coolPlacePos": "冷却摆放位置",
    "furnace": "炉",
    "foundPlace": "发现地点",
    "Programselectionerror": "程序选择错误",
    "Sterilizationfailure": "灭菌不合格",
    "Unqualifiedsterilizationloading": "灭菌装载不合格",
    "DeviceType": "设备类型",
    "goodsAccept": "物品接收",
    "unqualifiedBatch": "不合格批次",
    "packUnqualified": "包装不合格",
    "SupRegistration": "补登记",
    "issueUnqualified": "无菌发放不合格",
    "wetPackage": "湿包",
    "packRegisterMsg1": "包装不合格信息登记",
    "second": "秒",
    "hour": "小时",
    "continuation": "续用",
    "workloadStatistic": "工作量统计",
    "beforeCenter": "前者供应室",
    "afterCenter": "后者供应室",
    "statusNode": "流程节点",
    "handleCenterMsg": "该页面需要至少两个供应室才可使用",
    "handOverConfig": "自动交接",
    "elementSize": "元素尺寸",
    "elementPos": "元素位置",
    "saveFirst": "请先保存当前信息",
    "handleCenterMsg2": "前者供应室或后者供应室必须有一个是当前供应室",
    "applicationRecordBatchMsg": "当前申请记录里有不同批次，会被一起批量修改，是否继续",
    "newItemRecall": "新增物品召回",
    "recallInitiationDate": "召回发起日期",
    "sterilizationFailureReportPerson": "灭菌不合格报告人",
    "recallStartDate": "召回开始日期",
    "resultReviewer": "结果复核者",
    "recallCompletionDate": "召回完毕日期",
    "recallDeadline": "召回截止日期",
    "sterilizationBatchCode": "灭菌批次码",
    "undistributedList": "未发放列表",
    "issuedUnusedList": "已发放未使用列表",
    "issuedAndUsedList": "已发放已使用列表",
    "recalledList": "已召回列表",
    "sterilizationQuery": "灭菌查询",
    "nonConformanceReporter": "不合格报告人",
    "notRecalled": "未召回",
    "used": "已使用",
    "recallSuccessful": "召回成功",
    "packageHasUsedByPatient": "该包已被病人使用",
    "packageSuccessfullyRecalled": "该包已成功召回",
    "packageNotList": "该包未在列表中",
    "batchReassembly": "批量重新组配",
    "patientSurgicalName": "病人手术名称",
    "recallResults": "召回结果",
    "reassembleAll": "全部重新组配",
    "patientInfoRegistra": "病人信息登记",
    "pleaseSelectPackageReassembled": "请选择要重新组配的包",
    "planningArrangements": "计划安排",
    "taskArrangement": "任务安排",
    "taskType": "任务类型",
    "maintenanceInspectionType": "维护检测类型",
    "maintenanceManufacturer": "维保厂商",
    "faultOccurrenceTime": "故障发生时间",
    "reasonDescription": "原因说明",
    "newTask": "新建任务",
    "editTask": "编辑任务",
    "planType": "计划类型",
    "newPlan": "新建计划",
    "editPlan": "编辑计划",
    "deletePlan": "删除计划",
    "viewPlan": "查看计划",
    "viewTaskRecords": "查看任务记录",
    "nameSupplyRoom": "供应室名称",
    "cyclePeriod": "循环周期",
    "numberCycles": "循环次数",
    "taskRecord": "任务记录",
    "printAll": "全部打印",
    "notStarted": "未开始",
    "start": "开始",
    "completed": "已完成",
    "regularInspections": "定期巡检",
    "singlePlan": "单次计划",
    "isSureDelete": "是否确定删除",
    "notPrintableTasks": "没有可打印的任务",
    "taskStartTime": "任务开始时间",
    "maintenanceRecords": "维保记录",
    "cancelTask": "取消任务",
    "planNumber": "计划编号",
    "taskNumber": "任务编号",
    "faultTime": "故障时间",
    "maintenanceTime": "维保时间",
    "recordMaintenanceResults": "维保结果记录",
    "sterilizerName": "灭菌器名称",
    "viewTotalSterilizationItems": "查看灭菌物品合计",
    "viewSterilizationItems": "查看灭菌物品",
    "itemsInsideTheSterilizationRack": "灭菌架内物品",
    "heatNumber": "炉次",
    "decontaminationKitTotalNumber": "消毒包总工数量",
    "decontaminationTotalCost": "消毒总价",
    "dataDictionary": "数据字典",
    "numericalValue": "数值",
    "isCustom": "是否可自定义",
    "isDefaultSelected": "是否默认选中",
    "temperature": "温度",
    "PSSterilizer": "请选择灭菌人",
    "Additionelimination": "加消",
    "TendencyChart": "趋势图",
    "OutDepartmentCost": "发放科室成本",
    "DisinfectionSetCosts": "消毒包核价单价（元/个）",
    "notPackageSterilizationBatch": "不是该灭菌批次的包码",
    "Backwashingamount": "回洗金额",
    "referredtoas": "简称",
    "website": "网站",
    "businesslicense": "营业执照",
    "businessterm": "营业期",
    "Temporarybidding": "临时招标",
    "CompanyAddress": "公司地址",
    "Shortcannotbeempty": "简称不能为空",
    "Categorycannotbeempty": "类别不能为空",
    "Temporarybiddingcannotbeempty": "临时招标不能为空",
    "Devicecode": "器械码",
    "specifics": "详情",
    "RegistrationDepartment": "登记科室",
    "Usingsurgicaldepartment": "使用手术科室",
    "admissionnumber": "住院号",
    "registrationstatus": "登记状态",
    "Batchreturn": "批量归还",
    "Batchlogout": "批量注销",
    "logoff": "注销",
    "unregistered": "未登记",
    "registered": "已登记",
    "Pleaseselectrecord": "请选择记录",
    "Patientsurgicalinformation": "患者及手术信息",
    "ReturnInformation": "归还信息",
    "Manufacturerhandoverpersonnel": "厂家交接人员",
    "Operatingroompersonnel": "手术室人员",
    "Supplyroompersonnel": "供应室人员",
    "Handovertime": "交接时间",
    "currentpersonnelnotsupplyroom": "当前人员不属于供应室",
    "Batchcontinuation": "批量续用",
    "Continueddevices": "外来器械续用",
    "Plannedsurgery": "拟施手术",
    "PatientWard": "病人病区",
    "ExportOverview": "导出总览",
    "ExportDetails": "导出明细",
    "bulkedit": "批量编辑",
    "Exportdevicestatistics": "导出外来器械统计",
    "devicestatistics": "外来器械统计",
    "Cleaningbatch": "清洗批次",
    "Reviewedby": "复核人",
    "Secondaryrecycler": "二次回收人",
    "Secondaryrecoverytime": "二次回收时间",
    "Secondbackwashtime": "二次回洗时间",
    "Secondarybackwashingequipment": "二次回洗设备",
    "Secondarybackwashprocedure": "二次回洗程序",
    "Secondarybackwashbatch": "二次回洗批次",
    "Secondarybackwashperson": "二次回洗人",
    "Secondarybackwashresults": "二次回洗结果",
    "Cancellationtime": "注销时间",
    "Cancelledby": "注销人",
    "Cancellationhandoverperson": "注销交接人",
    "Returnedby": "归还人",
    "Returnhandoverperson": "归还交接人",
    "Returningphotos": "归还照片",
    "LogoutInformation": "注销信息",
    "EditingPatientInformation": "编辑病人信息",
    "Totalnumberexternaldevices": "外来器械总数",
    "Quantityrecycledafterexpiration": "过期后再被回收数量",
    "Numbernormalbackwashing": "正常返洗的数量",
    "Numberothercancellationreasons": "其他注销原因数量",
    "Quantitybackwashed": "待回洗数量",
    "Undistributedquantity": "未发放数量",
    "Pleaseselecdeviceedited": "请选择需要编辑的外来器械",
    "Borrowingreturningrecords": "借还记录",
    "Totalnumberimplantpackages": "植入物包数合计",
    "Totalnumberimplantedobjects": "植入物件数合计",
    "MenuID": "菜单ID",
    "ParentMenu": "父级菜单",
    "MenuName": "菜单名称",
    "MenuRouting": "菜单路由",
    "Menuicon": "菜单图标",
    "Menuimage": "菜单图片",
    "Menuorder": "菜单顺序",
    "Whetherbutton": "是否按钮",
    "DoesPDAdisplay": "PDA是否显示",
    "Isanexternalchain": "是否外链",
    "editMenu": "编辑菜单",
    "DoesthePCdisplay": "PC是否显示",
    "Modifyexpirationremindertime": "修改效期提醒时间",
    "Selfpackageoutboundregistration": "自用包出库登记",
    "Expiredpackageoutboundregistration": "过期包出库登记",
    "RecallInformation": "召回信息",
    "PacketCountQuery": "包计数查询",
    "Allocateoperatingrooms": "分配手术间",
    "Returningoperatingroom": "手术间退库",
    "Selfusepackageoutboundrecord": "自用包出库记录",
    "ExpiredPackageDeliveryRecord": "过期包出库记录",
    "Allocateoperatingroomrecords": "分配手术间记录",
    "Surgicalroomreturnrecord": "手术间退库记录",
    "Transferrecordoperatingroom": "手术间转让记录",
    "Deliverydate": "出库日期",
    "primary": "原",
    "Patientregistrationnot": "是否病人登记",
    "EnterthetagcodepressEnter": "输入标签码后回车",
    "Remindertimesterilewarehouseexpirationdate": "无菌库效期提醒时间",
    "Surgicalroomoutboundregistration": "手术间出库登记",
    "Stockreturnregistration": "退库登记",
    "Willnotjoinagain": "已经分配给手术间的包，不会再次加入分配",
    "Pleaseregisteroutboundperson": "请登记出库人",
    "realtimeprocessing": "请注意物品召回信息，及时处理",
    "Confirmstockreturn": "确认退库",
    "departmentcodeselected": "当前科室码不能选中",
    "additionalCharge": "附加费",
    "remark": "备",
    "Packagingstatistics": "包装统计",
    "mappingAssociation": "映射关联",
    "deleteMap": "删除映射",
    "patientsArticles": "病人物品",
    "selectionPatients": "选择病人",
    "periodhours": "实际计算效期为小时",
    "Assignedby": "分配人",
    "deletedstate": "删除状态",
    "Notdeleted": "未删除",
    "yesDeleted": "已删除",
    "Devicedetailscannobeempty": "器械明细不能为空",
    "SpecialRemarkcannobeempty": "特殊备注不能为空",
    "showPassword": "显示密码",
    "recycleInforMation": "回收信息",
    "recycleRemark": "回收备注",
    "syncCA": "同步CA",
    "toChoose": "待选",
    "functionConfig": "条件配置",
    "and": "并且",
    "equal": "等于",
    "greaterAndEqual": "大于或等于",
    "lessAndEqual": "小于或等于",
    "fixedValue": "固定值",
    "Othercourtyard": "其他院区",
    "CSSDhandover": "供应室交接",
    "CSSDhandoverItems": "供应室交接物品",
    "Applicationsamount": "申请金额",
    "Actualacceptanceamount": "实际受理金额",
    "ProcessInterruption": "流程中断",
    "ProcessInterruptionMsg": "勾选的包流程中断后无法包装，是否继续",
    "carrier": "载具",
    "registrationuseagain": "本次使用登记已达到器械最大使用次数，无法再次回收交接使用",
    "download": "下载",
    "noPage": "该页面无法访问或不存在",
    "reassemble": "重新组配",
    "printTime": "打印时间",
    "labelTemplateName": "标签模板名称",
    "packagMaterialName": "包装材料名称",
    "printedBy": "打印人",
    "supplementaryPrintDetails": "补打明细",
    "numberLabelsPrinted": "标签打印数量",
    "exportData": "导出图表",
    "numberPrinInstPacks": "打印器械包数量",
    "workloadStaff": "工作人员工作量",
    "reguPrinQuan": "常规打印数量",
    "quanSuppPrin": "补打数量",
    "PSLPR": "标签补打记录占比",
    "CDLPQ": "每日标签打印数量变化",
    "areRequired": "是必填的",
    "tagDesignPreview": "标签设计预览",
    "tagTemplate": "标签模板",
    "templateSize": "模板尺寸",
    "tagInfo": "标签信息",
    "saveAsTemplate": "保存为模板",
    "templateAlreadyExist": "当前模板已存在内容，是否覆盖？",
    "selectSizeFirst": "请先完成可选尺寸配置",
    "printTag": "打印标签",
    "yearMonthDay": "年月日",
    "hourMinuteSecond": "时分秒",
    "tagShowText": "标签显示文本",
    "sterilizeDeadline": "灭菌失效时间",
    "province": "省/直辖市",
    "city": "市",
    "district": "区",
    "county": "区/县/地级市",
    "dealerName": "经销商名称",
    "dealerRank": "经销商级别",
    "dealerLeader": "上级经销商",
    "contactName": "联系人名称",
    "contactPhone": "联系人电话",
    "tenantName": "租户名称",
    "userName": "用户姓名",
    "userAccount": "用户账号",
    "loginPwd": "登录密码",
    "confirmPwd": "确认密码",
    "assignTenant": "租户分配",
    "assignDepartment": "科室分配",
    "identity": "身份",
    "manageUser": "管理用户",
    "generalUser": "普通用户",
    "frozen": "冻结",
    "authorizeMethod": "授权方式",
    "tagNumbers": "标签数量",
    "addressNotEmpty": "地址不能为空",
    "timeNotEmpty": "时间不能为空",
    "confirmPwdNotEmpty": "确认密码不能为空",
    "mobileNotEmpty": "手机号不能为空",
    "tenantNotEmpty": "租户不能为空",
    "homePage": "主页",
    "basicData": "基础数据",
    "sendToTenant": "发送到租户",
    "changeTenant": "切换租户",
    "printWarning": "将消耗打印可用标签数量，是否继续操作？",
    "confirmToDisable": "确定禁用吗？",
    "cannotPrintByDelete": "该标签模版已被禁用，无法打印！",
    "downloadApp": "下载App",
    "printerNumber": "打印机编号",
    "notActive": "未激活",
    "activated": "已激活",
    "tenant": "租户",
    "activationTime": "激活时间",
    "preateNewPrinter": "新建打印机",
    "batchResetTenants": "批量重置租户",
    "summaryStatistics": "汇总统计",
    "modifyingPrinter": "修改打印机",
    "resetTenant": "重置租戶",
    "validityDeadline": "有效截止日期",
    "manufacturer": "生产厂商",
    "prinNumCannEmpt": "打印机编号不能为空",
    "bluetoothAddress": "蓝牙地址",
    "bluetAddrCannEmpty": "蓝牙地址不能为空",
    "machinSerNumber": "机器序列号",
    "seriNumCannEmpt": "机器序列号不能为空",
    "activaStati": "激活统计",
    "byTenant": "按租户",
    "activationDate": "激活日期",
    "encodePrinter": "按打印机编码",
    "datePrinCodeCreation": "打印机编码创建日期",
    "mainExpiDate": "维保到期日",
    "pleaEnteShipArea": "请输入发货区域",
    "pleaEnteValiBlueAddr": "请输入有效的蓝牙地址",
    "onlyPritActiStatRese": "只能重置状态是已激活的打印机数据",
    "areSureResetTenant": "是否确认重置租户",
    "resetSuccessful": "重置成功",
    "onlyPrinDataInacStatDele": "只能删除状态是未激活的打印机数据",
    "isSureDele": "是否确认删除",
    "onlyInacDataModi": "只能修改未激活的数据。",
    "verifTenants": "核销租户",
    "VerifTime": "核销时间",
    "codeValue": "码值",
    "batchVoid": "批量作废",
    "batchWithdWriteOffs": "批量撤回核销",
    "writeStati": "核销统计",
    "modifyQRCode": "修改二维码",
    "void": "作废",
    "withVeri": "撤回核销",
    "numberQRCodes": "二维码数量",
    "positiveDeviation": "正偏差",
    "verifDate": "核销日期",
    "sheet": "张",
    "writeOffUsers": "核销用户",
    "QRCodePreview": "二维码预览",
    "pleaEnteNumQR": "请输入二维码数量",
    "pleaEnteNumAbel": "请输入标签数量",
    "unprinted": "未打印",
    "verified": "已核销",
    "printSuccessful": "打印成功",
    "veriInvaDataCannInva": "已核销或作废的数据不能作废",
    "isBatcVoidSeleData": "是否确认批量作废选中的数据",
    "isVoidData": "是否确认作废该数据",
    "invalidSuccessfully": "作废成功",
    "onlyBatchWithdDataWrit": "只能批量撤回已核销的数据",
    "isBatcRetureSeleData": "是否确认批量撤回选中的核销数据",
    "isRetureSeleData": "是否确认撤回核销",
    "onlyRetureSeleData": "只能撤回已核销的数据",
    "withVeriSucc": "撤回核销成功",
    "veriInvDataCanotDele": "已核销或作废的数据不能删除",
    "isDeleSeleData": "是否确认删除选择的数据",
    "isDeleData": "是否确认该数据删除",
    "enterUserName": "请输入用户名",
    "enterPwd": "请输入密码",
    "selectCenter": "请选择处理中心",
    "selectDep": "请选择科室",
    "aboutProduct": "产品介绍",
    "systemManage": "系统管理",
    "scanAndDownload": "扫码下载（仅安卓）",
    "downloadPrinterDriver": "下载打印机驱动",
    "faqs": "常见问题",
    "activePrinter": "激活打印机",
    "useCode": "核销",
    "updateLog": "更新日志",
    "activeTip": "请扫描打印机编码和填写机器序列号",
    "printerCode": "打印机编码",
    "enterSerialCode": "请输入机器序列号后四位",
    "plaseScanQr": "请扫描标签二维码",
    "qrCode": "二维码编码",
    "userCenter": "个人中心",
    "name": "姓名",
    "phoneNumber": "手机号",
    "tenantExpire": "租户有效期",
    "tenantAvailableTags": "租户可用标签数量（张）",
    "tenantAvailablePrinters": "租户可用打印机数量（台）",
    "tenantOutDatedPrinters": "租户维保到期打印机数量（台）",
    "useTagRecord": "核销标签码记录",
    "activePrinterRecord": "激活打印机记录",
    "oldPwd": "旧密码",
    "inputOldPwd": "请输入旧密码",
    "newPwd": "新密码",
    "inputNewPwd": "请输入新密码",
    "pleaseConfirmPwd": "请确认密码",
    "printerFiles": "打印机文件",
    "pleaseScanPrinterCode": "请扫描打印机编号",
    "pleaseInputSerialCode": "请输入序列号后四位",
    "activePrinterSuccessfully": "打印机激活成功",
    "hospitalSize": "医院规模",
    "hospitalDepCount": "医院科室数量",
    "packageDealCountByDay": "日均器械包处理数量",
    "tagsPrintByDay": "日均标签数量",
    "hospitalSizeCannotBeNull": "医院规模不能为空",
    "hospitalDepCountCannotBeNull": "医院科室数量不能为空",
    "packageDealCountByDayCannotBeNull": "日均器械包处理数量不能为空",
    "tagsPrintByDayCannotBeNull": "日均标签数量不能为空",
    "announceBySMS": "短信通知",
    "confirmToSendSMS": "确定发送通知短信吗？",
    "jobPosition": "职务",
    "warehouseUser": "仓库用户",
    "pleaseSelectTenant": "请先选择租户",
    "pleaseSelectDataToDel": "请选择需要删除的数据",
    "pleaseSaveAndThenOperate": "请保存后再操作",
    "expirePerDay": "每月有效期",
    "validatyHour": "有效期小时",
    "validatyDay": "有效期天数",
    "pleaseSelectValidatyPeriodToSelect": "请选择要修改的有效期",
    "pleaseSelectDeviceStatus": "请选择设备状态",
    "pleaseSelectSteriMethod": "请选择灭菌方式",
    "pleaseSelectBioFrequency": "请选择生物监测频率",
    "greating": "您好!",
    "welcome": "欢迎来到标签管家！",
    "backToHome": "返回主页",
    "loginByApp": "登录app",
    "guideDoc": "说明文档",
    "contractDealer": "联系经销商",
    "buyFromDealer": "直销采购",
    "guideVideo": "演示视频",
    "printerUseVideo": "打印机安装视频",
    "SH": "上海市",
    "honjoMed": "上海红柚医疗器械有限公司",
    "honjoAddress": "上海市徐汇区钦州北路1188号科汇大厦1701室",
    "honjoTel": "4008938068",
    "changeBrowserAndRetry": "请使用自带浏览器打开当前链接并重试。",
    "checking": "检测中...",
    "onShelf": "上架",
    "offShelf": "下架",
    "locationIsRequired": "缺少位置信息",
    "swiperTitle": "轮播图标题",
    "showLoc": "显示位置",
    "linkAddress": "跳转地址",
    "uploadSizeRequire": "为保证手机端显示效果，请尽量选择500 x 265或等比缩放的图片。",
    "setPublishTime": "预定发布时间",
    "publish": "发布",
    "titleCannotBeNull": "标题不可为空",
    "locCannotBeNull": "位置不可为空",
    "orderCannotBeNull": "排序不可为空",
    "imgCannotBeNull": "图片不可为空",
    "publishTimeCannotBeNull": "发布时间不可为空",
    "announceContent": "公告内容",
    "timeRange": "时间范围",
    "modifyAnnounce": "修改公告",
    "sureToPublishAnnounce": "确定发布通知吗？",
    "publishSuccessfully": "发布成功！",
    "sureToDelAnnounce": "确定下架通知吗？",
    "offShelfSuccessfully": "下架成功！",
    "announcePublishTimeRange": "公告发布时间范围",
    "whetherToPublish": "是否发布",
    "startTimeCannotBeEarlyThanNow": "开始时间不得早于当前时间",
    "pleaseInputAnnounceContent": "请输入公告内容",
    "pleaseSelectTime": "请选择时间",
    "createAnnounce": "新建公告",
    "notPublished": "未发布",
    "publishing": "发布中",
    "publishStopped": "发布停止",
    "publishCompleted": "发布完成",
    "universalUse": "通用",
    "publishedMaintaining": "发版维护",
    "publishedVersion": "发布版本",
    "updatedLogTitle": "更新日志标题",
    "createUpdateLog": "新增更新日志",
    "modifyLog": "修改日志",
    "readLog": "查看日志",
    "publishTime": "发布时间",
    "updateLogContent": "更新日志内容",
    "publishedDataCannotBeDelete": "已经发布过的数据不能被删除",
    "allTenantCount": "全部租户数量",
    "userCount": "用户数量",
    "tenantActivedCount": "租户打印机激活数量",
    "innerPrinterActivedCount": "内部打印机激活数量",
    "statisticTitle1": "按租户统计 - 标签打印统计",
    "statisticTitle2": "标签打印总量日趋势",
    "statisticTitle3": "租户地域分布图",
    "statisticUnit1": "家",
    "tenantType": "租户类型",
    "tenantSize": "租户规模",
    "tenantSizeStatistic": "租户规模(日均处理)",
    "totalTagCount": "标签总数",
    "addTag": "添加标签",
    "publicTagInfo": "公用信息",
    "uniqueTagInfo": "个性信息",
    "printCount": "打印数量",
    "pleaseSelectTagTemplate": "请先选择标签模板",
    "processNumber": "流水号",
    "tagIdentifyCode": "标签识别码",
    "typeString": "字符",
    "typeCode128": "一维码",
    "typeDatamatrix": "DM码",
    "actualSize": "实际尺寸",
    "exportChart": "导出图表",
    "printingPlatform": "打印渠道",
    "printOnMobile": "移动端打印",
    "printOnPC": "PC端打印",
    "deviationNumber": "正偏差数量",
    "deviationValidateMsg": "请输入一个不超过10的数字",
    "printDate": "打印日期",
    "generateChart": "生成图表",
    "totalCount": "总计费用（元）",
    "byOutDepartment": "按发放科室",
    "to": "到",
    "summaryByDepartmentCost": "按科室费用汇总",
    "byInstrumentset": "按器械包",
    "summaryByInstrumentsetCost": "按器械包费用汇总",
    "noOutDepartment": "无发放科室",
    "cleaningvehicle": "清洗车",
    "notcleanedsimultaneously": "清洗车、器皿、篮筐器械不能同时清洗",
    "qualifyUserMsg": "请登记灭菌资质的人员",
    "qualifyUserMsg2": "第二次质检的人员不能和第一次的人相同",
    "programAstrict": "程序限制",
    "staging": "工作台",
    "Currenttotalreceived": "当前待接收总数",
    "distributedsameday": "当天发放总数",
    "ExpandAll": "全部展开",
    "collapseall": "全部折叠",
    "Rejectionoperation": "拒收操作",
    "IsUsed": "是否使用",
    "IsCancelled": "是否注销",
    "isReturned": "是否归还",
    "cancelCause": "注销原因",
    "receiversMinNumMsg": "清点人数量最少为",
    "BatchModify": "批量修改",
    "Cleaningrecordmodification": "清洗记录修改",
    "processPacketCount": "流程中包计数",
    "Interruptornot": "是否中断",
    "recordingtime": "记录时间",
    "Collectionrecord": "下收记录",
    "CollectionDepartment": "下收科室",
    "sterilizationProgramMsg": "个包按设定不能用当前灭菌程序开始，是否继续",
    "sterilizationProgramMsg2": "个包按设定不能用当前灭菌程序开始",
    "SummaryPackageQuantity": "包数量汇总",
    "Distributioncode": "发放码",
    "Onlyredemptionpackage": "只查兑换包",
    "Handwashprinting": "手洗打印",
    "Machinewashprinting": "机洗打印",
    "DiscoveryPrescription": "发现方科室",
    "qualityPrescription": "质检方科室",
    "cleanedNumber": "清洗总件数",
    "qualifiedNumber": "合格总件数",
    "unqualifiedNumber": "不合格总件数",
    "qualifiedRate": "合格率",
    "PotItem": "同锅物品",
    "firstCheckUid": "请扫描第一质检人",
    "secondCheckUid": "请扫描第二质检人",
    "packagenotfilteringcriteria": "该包不在筛选条件中",
    "Aresuretoreceiveall": "确认全部接收吗？",
    "Aresurereview": "确认审核接收吗？",
    "ReceiveTimeoutAlert": "接收超时提醒",
    "Choosingreturnedsterilization": "选择灭菌器是重新上架，不选则退回待灭菌",
    "reshelf": "重新上架",
    "instrumentPackageMsg": "包装方式处理方式不能为空",
    "instrumentPackageMsg2": "供应室的包不会自动发放，数值已改为-1",
    "OnlyRelevantPack": "仅查相关器械包",
    "ManufacturersContactWay": "厂家联系方式",
    "checkHasRecycledByCodesMsg1": "该包码已经回收，是否继续",
    "checkHasRecycledByCodesMsg2": "该包码已经回收，不能再次申请",
    "Oneclickreception": "一键接收",
    "selectSurgeryInfo": "请选择手术信息",
    "Synchronizeapplicationamount": "同步申请金额",
    "wantupdateapplicationpackage": "是否更新这个包的新申请费",
    "theme": "主题",
    "sterilestorageMsg": "该包不在灭菌质检列表中",
    "procedureErrorPlaceholder": "输入锅次后回车",
    "Allreturnstoinventory": "全部退库",
    "packagereturnTwo": "存在已有科室接受记录的包，是否将包退回？",
    "Recyclingregistrant": "回收登记人",
    "Repackaging": "重新包装",
    "Aresurerepackageit": "确定重新包装吗?",
    "Cleaningreview": "清洗复核",
    "wanttocontinue": "被删除的包有科室申请回收记录，需要重新回收，是否继续",
    "participationPack": "参与包装",
    "packType": "一检",
    "packageType2": "二检",
    "checkType": "三检",
    "belongdepartment": "归属科室不能为空",
    "packInList": "该包已在列表中",
    "SurgicalNumber": "手术单号",
    "version": "迭代版本",
    "display": "显示内容",
    "processConfiguration": "流程配置",
    "divtConfiguration": "字典配置",
    "processConfigurationName": "流程配置名称",
    "configurationRemark": "配置描述",
    "processConfigurationID": "流程配置ID值",
    "divtConfigurationName": "字典配置名称",
    "divtConfigurationType": "字典配置Type值",
    "newIssue": "新发放重构版",
    "scanCodeMode": "扫码模式",
    "ConfigurationValue": "配置值",
    "typeValue": "类型值",
    "pageDisplay": "页面显示",
    "GeneralSerrings": "通用设置",
    "PrintAbout": "打印相关",
    "ScheduledExpirationReminder": "计划到期提醒",
    "Otherinformation": "其他信息",
    "Departmentaltransfertime": "转入科室时间",
    "Departuretransfertime": "转离科室时间",
    "Departmentalorderprinting": "科室分单打印",
    "Dateandtimeempty": "日期时间不能为空",
    "Recyclingpackagecode": "回收包码",
    "defaultUrgent": "默认加急",
    "noUrgent": "不加急",
    "Packaginginquirylabel": "包装查询用标签",
    "Statisticalcycle": "统计周期",
    "Statisticalprocess": "统计流程",
    "Statisticalcalculation": "统计计算",
    "Unitpriceamount": "单价金额",
    "Carvingcodepackage": "刻码包",
    "Byengravingcode": "按刻码",
    "Bypackagename": "按包名",
    "Bynumberofpackages": "按包数",
    "statisticalsummary": "统计汇总",
    "Bypackagecategory": "按包类别",
    "Bypackageclassname": "按包类名",
    "Accordingtopackagespecifications": "按包规格",
    "Bypackagetype": "按包类型",
    "Groupbypackage": "按包分组",
    "Byinstrumentpackagename": "按器械包名称",
    "Bydepartment": "按科室",
    "Pleaseselectthesummarytype": "请选择统计汇总",
    "Exportsuccessful": "导出成功",
    "Jumptoqueryfiles": "跳转查询文件",
    "cancelLog": "取消发放日志",
    "Inventorysheetprinting": "清点单打印",
    "operationTime": "操作时间",
    "operateComputer": "操作电脑",
    "Biologicalpackageprinting": "生物监测包打印",
    "BDpackageprinting": "BD监测包打印",
    "vesselNumberMsg": "请填写器皿数量",
    "packagingTimeRequired": "请填写包装时间",
    "clearingRemind": "有部分包的回收时间和本次清洗时间矛盾，需要修改回收时间后才可以补录",
    "outerNameSelect": "请选择验证通过的包名",
    "hiddenInventory": "隐藏库存数0",
    "Sterilizerperson": "灭菌员",
    "Feedepartment": "收费科室",
    "expiringdate": "失效日期",
    "PatientRegistration": "病人登记",
    "minCostamount": "最小单位成本金额",
    "packageSummary": "包类汇总",
    "releaseSummary": "发放分类汇总",
    "equipmentOperation": "设备运行",
    "washingVessel": "清洗器皿",
    "highLevelWorkload": "高水平工作量",
    "Tobeassembled": "待组配",
    "PrintInformation": "打印信息",
    "sterilizationManyPack": "上架0个包",
    "sterilizationManyPackMsg": "该列表目前没有可上架的包",
    "existingdepartment": "请选择已有的科室",
    "itemdetailsbeempty": "物品明细不能为空",
    "msg2Issue": "无菌库有",
    "msg3Issue": "件包过期，",
    "msg4Issue": "件包即将过期，",
    "msg5Issue": "是否立刻处理？",
    "Equipmentnumber": "设备编号",
    "Unusedquantity": "未使用数量",
    "sterilizationManyPackMsg2": "本次上架0个包，请确认。",
    "PrintSettings": "打印设置",
    "Packagingtotalcode": "包装总码",
    "packagePrintMsg": "该包是刻码包但缺少刻码信息，请删除后重新回收",
    "Unqualifiedcleaningandreturn": "清洗不合格退回",
    "Unqualifiedsterilizationandreturn": "灭菌不合格退回",
    "Packagingreturn": "包装退回",
    "Notequalto": "不等于",
    "Empty": "为空",
    "Notempty": "不为空",
    "Basicinformationsupplement": "基础信息（补充）",
    "Selectatleastonetimerange": "至少选择一个时间范围",
    "tardive": "迟发",
    "Unregisteredpatients": "未登记病人",
    "isContinuation": "是否续用",
    "renewCode": "续用包码",
    "Shortesttime": "最短时间",
    "Maximumtime": "最长时间",
    "Maximumtimenotempty": "最长时间不能为空",
    "Shortesttimenotempty": "最短时间不能为空",
    "sterilizingRack": "上灭菌架",
    "InMachineSterilization": "进机灭菌",
    "ChangeSterilizer": "更换灭菌器",
    "MonitorPackagePrinting": "监测包打印",
    "soldOut": "下架",
    "sterilizationMsg": "请选择灭菌架",
    "ChangeShelf": "更换灭菌架",
    "sterilizationMsg2": "请选择要下架的包",
    "putaway": "上架",
    "inEquipment": "进机",
    "sterilizationMsg3": "请配置灭菌架",
    "ScanTheShelf": "扫码上架",
    "ScanOffTheShelf": "扫码下架",
    "sterilizationMsg4": "请选中灭菌器或者灭菌架",
    "sterilizationMsg5": "请配置灭菌器",
    "BatchMonitoringPrint": "批量监测包打印",
    "allShelfDelete": "整架移除",
    "setTotalCount": "包合计",
    "DeviceSystemCode": "设备系统编码",
    "IsBindingSterilizer": "是否绑定灭菌架",
    "BindingSterilizer": "绑定灭菌架",
    "Newequipmentpackageoutbound": "新建器械包出库",
    "Createanewoutboundtask": "新建出库任务",
    "Outboundtype": "出库类型",
    "Numbernewpackages": "新建器械包数量",
    "Requestforoutboundquantity": "申请出库数量",
    "ProgramRemarks": "程序备注",
    "sterilizationMsg6": "请扫选中灭菌器的程序码",
    "Newpackage": "新包",
    "Theoperatingroomcannotbeempty": "手术间不能为空",
    "ConsumerSchool": "消供学园",
    "OfficeAsepticLibrary": "科室无菌库",
    "scrutineer": "检查者",
    "RecyclingComparison": "回收使用对比",
    "Addcustomfields": "添加自定义字段",
    "CustomFieldName": "自定义字段名称",
    "CustomFieldValues": "自定义字段值",
    "GXYDrRgistrationMsg": "病人名称不一致，不能保存，请修改",
    "SterilizationQualityUser": "灭菌质检员",
    "scanSterilizationQualityUser": "请扫描灭菌质检员",
    "questiontypeGroup": "问题组",
    "Summaryprinting": "汇总打印",
    "checkEquipment": "设备检测",
    "backWashingRate": "反洗率",
    "outDatedInstrumentsetsCannotBeAssigned": "过期包不能分配手术间",
    "Viewphotos": "查看图片",
    "cleanStartTime": "清洗开始时间",
    "exportDetail": "明细导出",
    "infectedInstrumentSetCount": "感染器械包总数量",
    "infectedInstrumentCount": "感染器械总数量",
    "Nopicturesavailable": "无图片显示",
    "DepartmentAggregationExport": "科室聚合导出",
    "Exportconsumablesdetails": "耗材明细导出",
    "Pleaseselectthedistributiontime": "请选择发放时间",
    "Totalnumberbasicdatainstruments": "基础数据器械数量合计",
    "Totalnumberactualprocessinstruments": "实际流程器械数量合计",
    "Externaldeviceprinting": "外来器械打印",
    "warehouseMsg": "不可批量选择器械包，请单独登记器械包",
    "equipmentMsg": "不能打印的数据",
    "Recyclingdepartmentgroup": "回收科室组",
    "Batchoperations": "批量操作",
    "totalCostedFee": "总计加消费用",
    "biologicalMonitoringDay": "生物监测天数",
    "biologicalMonitoringMsg": "已超过x天未生物监测",
    "common": "共",
    "Departmentcategory": "科室类别",
    "Packagegrouping": "包分组",
    "addIntoPackaging": "加入包装代消",
    "Printseparately": "单独打印",
    "useDeadline": "使用期限",
    "notFilled": "未填写",
    "haveExpired": "已过期",
    "committed": "已提交",
    "Statisticaldimension": "统计维度",
    "Statisticalsupplyroomequipmentpackage": "统计供应室器械包",
    "StatisticalDataSpecification": "统计数据规范",
    "Basicdata": "基础数据",
    "Processdata": "流程数据",
    "AddCancelModify": "加消修改",
    "secondIssueRightMsg6": "当前列表包数超过500，请重新筛选后，再登记发放包",
    "isCollection": "默认集采",
    "sterilizedShelvesNumber": "当前灭菌架上架数量",
    "sterilizerMachinesNumber": "当前灭菌器进机数量",
    "area": "区域",
    "handoverRegistration": "交班登记",
    "Totalnumberofdevices": "器械总件数",
    "CleaningHistory": "清洗历史记录",
    "collation": "核对",
    "Cleaningmachineparameterverification": "清洗机参数核对",
    "Verifytheresults": "核对结果",
    "Verifier": "核对人",
    "spareBag": "备用包",
    "operationScheduleTime": "手术排台时间",
    "Urgentmodification": "修改加急",
    "Scanningtime": "扫码的时间",
    "ReturnPackage": "退回包",
    "successIn": "成功加入",
    "removbasketitem": "是否移除这行物品的篮筐",
    "operationStorage": "出库器械包提醒",
    "cancelReviewReject": "取消审核并驳回",
    "recycleTrack": "回收查询",
    "reasonDeletion": "请选择删除原因",
    "selectreasonDeletion": "请选择核对人",
    "urgentReason": "加急原因",
    "withdraw": "撤回",
    "Batchrecycling": "批量回收",
    "Withdrawalsuccessful": "撤回成功",
    "Recyclinginprogress": "正在回收",
    "PatientID": "病人id",
    "warehouseMsg1": "请选择出库日期再尝试导出",
    "Cannotexpedite": "无法加急",
    "Thispackageunableexpedited": "该包被设定为无法加急",
    "clearAllCost": "清洗总计费用",
    "packAllCost": "包装总计费用",
    "sterilizationAllCost": "灭菌总计费用",
    "issueAllCost": "发放总计费用",
    "otherAllCost": "其他总计费用",
    "totalIssue": "总计发放",
    "totalCost": "总计费用",
    "synchronizingInformation": "同步信息",
    "ordernoMsg1": "已经登记过，请勿重复记录",
    "ordernoMsg2": "已经记录了厂家、病人、包信息，是否覆盖？",
    "Longqueueforcleaningmachines": "长龙清洗机排队",
    "Entrysequence": "进舱顺序",
    "Numberofbasketscleaned": "清洗篮筐数",
    "cacheList": "暂存列表",
    "containerCode": "篮筐编码",
    "cancelStaging": "取消暂存",
    "isCancelStaging": "是否取消暂存",
    "pleaseCancelStaging": "请勾选要取消暂存的项",
    "pleaseCancelStaging1": "请勾选要暂存的項",
    "Settlementreport": "结算报表",
    "Settlementresults": "结算结果",
    "stagingCause": "暂存原因",
    "Theregistrantcannotempty": "登记人不能为空",
    "Theoperatingroomcannotempty": "手术间不能为空",
    "DistributionDepartmentTeam": "发放科室组",
    "cameraID": "摄像头ID",
    "cameraLabel": "摄像头名称",
    "forFaceIdentificationLogin": "人脸识别登录",
    "Lowtemperaturesterilizationcost": "低温灭菌费用",
    "Lowtemperaturesterilizationcostcalculation": "低温灭菌费用计算",
    "Calculatesterilizationcost": "计算灭菌费用",
    "Wholepotsterilizationcost": "整锅灭菌费用(元)",
    "faceIdentificationCameraNotExist": "当前记录的用于人脸识别的摄像头不存在，请重新设置",
    "Costallocationaccountingsterilizationequipment": "灭菌设备分摊成本核算",
    "Facialdatabase": "人脸库",
    "Activatefacialrecognition": "激活人脸识别",
    "Searchbydepartment": "按科室查询",
    "Searchbysterilizationbatchnumber": "按灭菌批次号查询",
    "Sterilizationsharingtotalcost": "灭菌分摊总成本",
    "secondIssueRightMsg7": "无菌库存在未发放完成的器械包，是否跳转处理",
    "weightReason": "称重异常原因",
    "weightAbnormalMsg": "称重异常，请选择原因",
    "Selectprogramagain": "选中灭菌器，请再次扫描选中程序",
    "Programselectionsuccessful": "程序选择成功",
    "sterilizationIssuedMsg": "本次灭菌已发放完毕",
    "scanCodeCheck": "扫码勾选",
    "scanCancellation": "扫码取消",
    "Samenamepackageaggregationsorting": "同名包聚合排序",
    "nonconformingPart": "不合格部位",
    "engravingRestoration": "刻码修复",
    "restoration": "修复",
    "recycleMsg": "会让这个包恢复到可以回收的状态，是否继续",
    "vesselNumberMsg2": "请选择器皿",
    "actualWeight": "实际重量",
    "designWeight": "设计重量",
    "checkedPack": "已勾选",
    "classifier": "分类人",
    "foreignInstrumentsUsed": "外来器械常用",
    "qualitySupplementRegistration": "质控补登记",
    "equipmentRegistration": "设备登记",
    "operatorSelection": "请选择操作人",
    "Surgerycompleted": "手术结束",
    "searchitemsbatch": "是否查询同批次回收的物品",
    "Usagesituation": "使用情况",
    "transferredpatientrecordcontinue": "包会转移到当前病人记录，是否继续",
    "endsurgery": "确认结束手术吗？",
    "Bydate": "按日期",
    "uniLogin": "单点登录",
    "Maximumpackaginglimit": "包装最大数限制",
    "Whetherregistration": "是否使用登记",
    "Querywarehousedepartment": "科室无菌库查询",
    "sterilizationStartTime": "灭菌开始时间",
    "Pleaseuploadagain": "请重新上传",
    "Packagingsplit": "包装拆分",
    "BatchSplitting": "批量拆分",
    "instrumentPackageMsg3": "拆分后该包流程终止",
    "cleaningBagAssembly": "洁包组配",
    "packagePrintMsg2": "没有可拆分的包",
    "cleaningInspector": "清洗质检人",
    "sweepCoding": "扫描编码",
    "Temperaturepressurenumber": "温压仪编号",
    "Temperaturepressurerecord": "温压仪记录",
    "questionContent": "问题内容",
    "descriptionContent": "说明内容",
    "readed": "已读",
    "unRead": "未读",
    "markAllAsReaded": "全部标记为已读",
    "whetherMarkAllAsReaded": "是否全部标记为已读？",
    "china": '中国',
    "malaysia": "马来西亚",
    "country": "国家",
    "systemName": "红柚“安易溯”标签管家",
    "tenantState": "租户状态",
    "contractType": "合同类型",
    "official": "正式",
    "trial": "试用",
    "contractNumber": "合同编号",
    "contractNumberFormatError": "合同编号格式错误",
    "contractNumberCannotBeNull": "合同编号不能为空",
    "userType": "用户类型",
    "dealerUser": "经销商用户",
    "tenantUser": "租户用户",
    "assignDealer": "经销商分配",
    "emailAddress": "电子邮件地址",
    "dealerNotEmpty": "经销商不能为空",
    "identityNotEmpty": "身份不能为空",
    "userTypeNotEmpty": "用户类型不能为空",
    "emailFormatError": "请填写正确的电子邮件地址",
    "dataLableNotEmpty": "数据标签不能为空",
    "dataKeyValueNotEmpty": "数据键值不能为空",
    "displaySortingNotEmpty": "显示排序不能为空",
    "divtNameNotEmpty": "字典名称不能为空",
  }
}